const axios = require('axios');
const rax = require('retry-axios');
var _ = require('lodash');

var Preconditions = require('./Preconditions.js'); 
var Labels = require('./Labels.js'); 
var ConversationSummaries = require('./ConversationSummaries.js'); 
var Conversation = require('./Conversation.js');
var LocalStorage = require('./LocalStorage.js'); 
const Task = require('./Task.js'); 
const { v4: uuidv4 } = require('uuid');
const E164 = require('./E164.js'); 

var Ably = require('ably');
const BlobMetaData = require('./BlobMetaData.js');
const RedChirpState = require('./RedChirpState.js');
const RedChirpAbly = require('./RedChirpAbly.js');
const Utils = require('./utils.js');
const Time = require('@/js/time.js');
const Millicents = require('@/js/millicents.js');
const enum_data = require('@/js/enums-data.json');
const static_data = require('@/js/static-data.json');
const emoji_data = require('@/js/emoji-data.json');
const TestData = require("@/js/TestData.js");

const FingerprintJS = require('@fingerprintjs/fingerprintjs-pro');

const VersionService = require('@/js/HashVersion.js');

const interceptorId = rax.attach();
const raxConfig = {
    // Retry 3 times on requests that return a response (500, etc) before giving up.  Defaults to 3.
    retry: 2,

    // Retry twice on errors that don't return a response (ENOTFOUND, ETIMEDOUT, etc).
    noResponseRetries: 2,

    // Milliseconds to delay at first.  Defaults to 100. Only considered when backoffType is 'static'
    retryDelay: 100,

    // HTTP methods to automatically retry.  Defaults to:
    // ['GET', 'HEAD', 'OPTIONS', 'DELETE', 'PUT']
    httpMethodsToRetry: ['GET', 'HEAD', 'OPTIONS', 'DELETE', 'PUT', 'LIST'],

    // The response status codes to retry.  Supports a double
    // array with a list of ranges.  Defaults to:
    // [[100, 199], [429, 429], [500, 599]]
    statusCodesToRetry: [[100, 199], [429, 429], [500, 599]],

    // You can set the backoff type.
    // options are 'exponential' (default), 'static' or 'linear'
    backoffType: 'exponential',

    // You can detect when a retry is happening, and figure out how many
    // retry attempts have been made
    onRetryAttempt: err => {
      const cfg = rax.getConfig(err);
    }
  }

function RedChirp(event_bus)
{
    Preconditions.checkNotNull(event_bus);
    this.$event_bus = event_bus;

    this.$state = new RedChirpState();
    this.$ably = new RedChirpAbly(this);
    this.updateFingerprint();
    this.request_time_map = new Map();
}

RedChirp.prototype.ORG_ID_TEST_CHIRP 					= 'd0a00313-4d12-4d05-9fad-5203575674e6';
RedChirp.prototype.ORG_ID_RED_ROCK_REALTY 				= '8a732595-6621-4d6d-af37-0819110ae721';
RedChirp.prototype.ORG_ID_RED_COUNTRY_JEEP_TOURS 		= '0f0b45f1-9dfb-468d-bcd4-fcb49ef01154';
RedChirp.prototype.ORG_ID_RED_STALLION_BUGGY_WHIPS      = '4910a846-3c25-11eb-adc1-0242ac120002';
RedChirp.prototype.ORG_ID_CLASS_VI_PARTNERS             = '157ef3e1-23ce-432f-8b24-6bb064720906';
RedChirp.prototype.ORG_ID_RED_CHIRP                     = '53485c43-8d64-4be9-82fa-6ae2b4efe575';

RedChirp.prototype.uuidv4 = function()
{
    return uuidv4();
}

RedChirp.prototype.emojis = function() 
{
    return emoji_data;
}

RedChirp.prototype.rest = function(endpoint, params, on_success, on_error)
{
    let modern_timeout = null;

    if ( typeof endpoint != 'string' )
    {
        // Second version of the function where an object is taken...
        let rest_params = endpoint;

        if ( rest_params.spinner == null ) rest_params.spinner = false;
        if ( rest_params.params == null ) rest_params.params = {};
        if ( rest_params.on_success == null ) rest_params.on_success = () => {};
        if ( rest_params.on_error == null ) rest_params.on_error = () => {};
        if ( typeof rest_params.on_error == 'string' ) 
        {
            let error_text = rest_params.on_error;
            rest_params.on_error = () => { this.alert('Error', error_text, () => {}, true); }
        }
        
        if ( rest_params.timeout == 'default' ) rest_params.timeout = null;
        if ( typeof rest_params.timeout == 'string' ) rest_params.timeout = Time.getDurationAsMilliseconds(rest_params.timeout);
        if ( rest_params.timeout != null ) modern_timeout = rest_params.timeout;

        if ( rest_params.spinner == true )
        {
            let tmp_on_success = rest_params.on_success;

            rest_params.on_success = (data) => {
                this.hideSpinner();
                tmp_on_success(data);
            };

            let tmp_on_error = rest_params.on_error;

            rest_params.on_error = (data) => {
                this.hideSpinner();
                tmp_on_error(data);
            };

            this.showSpinner(); // show the spinner now, a success or error will hide it...
        }

        endpoint = rest_params.endpoint;
        params = rest_params.params;
        on_success = rest_params.on_success;
        on_error = rest_params.on_error;
    }

    let api_call_data = Utils.createRestCallData(endpoint, params);

    api_call_data.on_response = 'onResponseStandard';
    api_call_data.on_response_params = { 'on_success' : on_success, 'on_error' : on_error };
    if ( modern_timeout != null ) api_call_data.timeout = modern_timeout;

    this.makeApiCall(api_call_data);
}

RedChirp.prototype.defaultDebounceTime = function()
{
    return 750;
}

RedChirp.prototype.updateProfile = function(new_profile)
{
    this.$state.updateProfile(new_profile);
    this.$ably.update();
    this.getAllEndpointConversationSummaries(); // get conversation summaries for all endpoints...
}

RedChirp.prototype.setSSOCompletionInProgress = function(inProgress)
{
    this._sso_completion_in_progress = inProgress;
}

RedChirp.prototype.setAuthCompletionInProgress = function(inProgress)
{
    this._auth_completion_in_progress = inProgress;
}



RedChirp.prototype.$emit = function(event_name, data)
{
    this.$event_bus.$emit(event_name,data);
}

// smart pretty printing function
RedChirp.prototype.pretty = function(val, type)
{
    if ( type == 'endpoint_no_parens' )
    {
        if ( val == null ) return null;
        return E164.prettyPrintUsPhoneNumberNoParens(val);
    }

    if ( type == 'endpoints' )
    {
        let str_vals = [];

        if ( val == null )
            return null;

        for ( let i = 0; i < val.length; i++ )
        {
            str_vals.push(E164.prettyPrintUsPhoneNumberNoParens(val[i]));
        }

        return this.pretty(str_vals, 'comma_list');
    }

    if ( (''+val).startsWith('E164:') && type != 'comma_list' )
    {
        return E164.prettyPrintUsPhoneNumber(val);
    }

    if ( type == 'date' )
    {
        if ( val == null || val == 0 ) return null;
        return Time.getISODate(val);
    }

    if ( type == 'integer' || type == 'int' )
    {
        if ( val == null ) return null;
        if ( typeof val === 'string' ) val = parseInt(val);
        if ( isNaN(val) ) return null;
        
        return val.toLocaleString();
    }

    if ( type == 'time' )
    {
        if ( val == null || val == 0 ) return null;
        return Time.getPeriodClockTime(val);
    }

    if ( type == 'date_and_time' )
    {
        if ( val == null || val == 0 ) return null;
        return Time.getTimeAndDate(val);
    }

    if ( type == 'millicents' )
    {
        return Millicents.prettyPrint(val);
    }

    if ( type == 'millicents_dollars' )
    {
        return Millicents.prettyPrintDollars(val);
    }

    if ( type == 'millicents_whole_dollars' )
    {
        return Millicents.prettyPrintWholeDollars(val);
    }

    if ( type == 'millicents_whole_dollars_accounting' )
    {
        return Millicents.prettyPrintWholeDollarsAccounting(val);
    }

    if ( type == 'milli_pct' ) 
    {
        return val / 1000+'%';
    }

    if ( type == 'usd' )
    {
        return Millicents.prettyPrintDollars(val);
    }

    

    if ( type == 'boolean_yes_no')
    {
        if ( val == true )
            return 'Yes';
        
        return 'No';
    }

    if ( type == 'duration')
    {
        return Time.prettyPrintDuration(val);
    }

    if ( type == 'space_list' )
    {
        let ret = '';

        for ( let i = 0; i < val.length; i++ )
        {
            if ( ret.length > 0 )
                ret += ' ';
            
            ret += ''+val[i];    
        }

        return ret.trim();
    }


    if ( type == 'comma_list' )
    {
        let ret = '';

        for ( let i = 0; i < val.length; i++ )
        {
            if ( ret.length > 0 )
                ret += ', ';
            
            ret += ''+val[i];    
        }

        return ret;
    }

    if ( type == 'semi_list' )
    {
        let ret = '';

        for ( let i = 0; i < val.length; i++ )
        {
            if ( ret.length > 0 )
                ret += '; ';
            
            ret += ''+val[i];    
        }

        return ret;
    }

    if ( type == 'br_list' )
    {
        let ret = '';

        for ( let i = 0; i < val.length; i++ )
        {
            if ( ret.length > 0 )
                ret += '<br/>\n';
            
            ret += ''+val[i];    
        }

        return ret;
    }

    if ( type == 'comma_and_list' )
    {
        let ret = '';

        for ( let i = 0; i < val.length; i++ )
        {
            if ( ret.length > 0 && i != val.length-1 )
                ret += ', ';

            else if ( ret.length > 0 && i == val.length-1 )
            {
                ret += ' and ';
            }
            
            ret += ''+val[i];    
        }

        return ret;
    }

    if ( type == 'file_size' )
    {
        if ( val == null ) return null;

        val = Math.floor(val);

        if ( val < 1024 ) return val+' bytes';

        val = Math.ceil(val / 1024);

        if ( val < 1024 ) return val+' kb';

        val = Math.ceil(val / 1024);

        if ( val < 1024 ) return val+' mb';

        val = Math.ceil(val / 1024);

        if ( val < 1024 ) return val+' tb';

        val = Math.ceil(val / 1024);

        return val+' tb';
    }

    if ( type == 'integration_name' )
    {
        let choices = this.enumChoices('integration_name');

        for ( let i = 0; i < choices.length; i++ )
        {
            if ( choices[i].value == val )
                return choices[i].text;
        }
    }

    if ( type.startsWith('enum_') )
    {
        let choices = this.enumChoices(type.substring('enum_'.length));

        for ( let i = 0; i < choices.length; i++ )
        {
            if ( choices[i].value == val )
                return choices[i].text;
        }
    }
    
    return ''+val;
}


RedChirp.prototype.currentTimeZone = function()
{
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

RedChirp.prototype.commonTimeZonesWithCurrentTimeZone = function()
{
    let current_timezone = this.currentTimeZone();
    let time_zones = this.commonTimeZones();

    if ( current_timezone == null ) 
        return time_zones;

    for ( let i = 0; i < time_zones.length; i++ )
    {
        if ( time_zones[i] == current_timezone ) 
            return time_zones;
    }

    time_zones.push(current_timezone);
    return time_zones;
}

RedChirp.prototype.commonTimeZones = function()
{
    return TestData.getCommonTimeZones();
}

RedChirp.prototype.enumChoices = function(enum_name, include_any_or_none, any_label)
{
    if ( any_label == null ) any_label = '(any or none)';

     if ( include_any_or_none === false )
     {
        return enum_data[enum_name];
     }

    return [
        {'text' : any_label, 'value' : 'any_enum_value' }, // any_integration, integrationChoices(), 'integration_name'
    ]
    .concat(enum_data[enum_name]);
}

RedChirp.prototype.getStatic = function(path)
{
    return this.getDeep(static_data, path);
}

RedChirp.prototype.enumObject = function(enum_name, value)
{
    let arr = enum_data[enum_name];

    if ( arr == null ) return null;

    for( let i = 0; i < arr.length; i++ )
    {
        if ( arr[i].value == value )
        {
            return arr[i];
        } 
    }

    return null;
}

RedChirp.prototype.enumValues = function(enum_name)
{
    return enum_data[enum_name];
}

RedChirp.prototype.isEnumAny = function(value)
{
    if ( value == null ) return true;
    if ( value == 'any_enum_value' ) return true;

    return false;
}

/**
 * Get all integrations that support a specific feature.
 *
 * @param {string} feature_identifier - The feature identifier (e.g., "use-site-visitor-authentication-status")
 * @param {function} on_success - Callback function that receives the list of supporting integrations
 * @param {function} on_error - Callback function for error handling
 */
RedChirp.prototype.getIntegrationsForFeature = function(feature_identifier, on_success, on_error)
{
    this.rest({
        'spinner': false,
        'endpoint': 'GET: /api/v1/integrations/feature-support/' + encodeURIComponent(feature_identifier),
        'on_success': (data) => {
            if (on_success) {
                on_success(data.supporting_integrations || []);
            }
        },
        'on_error': (error) => {
            if (on_error) {
                on_error(error);
            }
        }
    });
}

RedChirp.prototype.isValidEnumValue = function(value, enum_name)
{
    if ( value == null ) return false;
    if ( value == 'any_enum_value' ) return false;
    if ( value.trim().length == 0 ) return false;

    let possible_values = this.enumValues(enum_name);

    for ( let i = 0; i < possible_values.length; i++ )
    {
        if ( possible_values[i].value == value ) return true;
    }

    return false;
}



RedChirp.prototype.onMessage = function(message)
{
    let signal = JSON.parse(message.data);
    let signal_type = signal.signal_type;

    if ( signal_type === 'endpoint-update-conversation' )
    {
        this.onSignalUpdateConversation(signal);
        return;
    }

    if ( signal_type == 'endpoint-update-is-typing' )
    {
        this.$emit('endpoint-update-is-typing', signal);
        return;
    }

    if ( signal_type == 'common-update-contact' )
    {
        this.$emit('update-contact', signal);
        return;
    }

    if ( signal_type === 'endpoint-update-conversation-summary' )
    {
        this.onSignalUpdateConversationSummary(signal);
        return;
    }

    if ( signal_type === 'common-update-label' )
    { 
        this.updateOneLabel(signal.endpoint);
        return;
    }

    if ( signal_type === 'common-employee-notification' )
    { 
        this.onEmployeeNotification(signal);
        return;
    }

    if ( signal_type === 'common-update-pickup' )
    { 
        this.$emit('update-pickup', signal);
        return;
    }


    if ( signal_type === 'common-upsert-contact-request' )
    { 
        this.onUpsertContactRequest(signal.contact_request_id);
        return;
    }

    if ( signal_type === 'common-upsert-payment' )
    {
        this.$emit('upsert-payment', signal.payment_id);
        return;
    }

    if ( signal_type === 'common-blob-metadata-update' )
    { 
        this.onBlobMetaDataUpdate(signal);
        return;
    }

    if ( signal_type === 'common-excel-export-progress' )
    { 
        this.$emit('excel-export-progress', signal);
        return;
    }

    if ( signal_type === 'common-bulk-message-send-progress' )
    {
        this.$emit('common-bulk-message-send-progress', signal);
        return;
    }

    if ( signal_type === 'common-bulk-message-import-progress' )
    {
        this.$emit('common-bulk-message-import-progress', signal);
        return;
    }

    if ( signal_type === 'common-contact-request-is-typing' )
    {
        this.$emit('common-contact-request-is-typing', signal);
        return;
    }

    if ( signal_type === 'common-validate-auth' )
    {
        if ( this.$state.employee_id !== signal.employee_id )
            return;

        this.onValidateAuth();
        return;
    }

    if ( signal_type === 'common-rekognition-response' )
    {
        if ( this.$state.organization_id !== signal.organization_id )
            return;

        this.$emit('common-rekognition-response', signal);
        return;
    }

    if ( signal_type === 'common-employee-profile-changed' )
    {
        if ( this.$state.employee_id !== signal.employee_id )
            return;

        this.onValidateAuth();
        return;
    }

    if ( signal_type == 'common-update-employee-dnd' )
    {
        this.$emit('common-update-employee-dnd', signal);
        return;
    }

    if ( signal_type == 'common-update-organization' )
    {
        this.$emit('common-update-organization', signal);
        return;
    }

    if ( signal_type == 'common-call-start-ringing' )
    {
        this.$emit('call-start-ringing', signal);
        return;
    }

    if ( signal_type == 'common-call-stop-ringing' )
    {
        this.$emit('call-stop-ringing', signal);
        return;
    }
}



RedChirp.prototype.playSound = function()
{
    if ( this.$state.muted ) 
        return;
    
    let url = this.$state.profile.extended_data.alert_sound_url;

    if ( url == null ) 
        return;

    try
    {
        var audio = new Audio(url);
        audio.play();
    }
    catch(err)
    {
        let i = 2; // error is produced if we don't have some code here...
    }
}

RedChirp.prototype.onSignalUpdateConversation = function(signal)
{
    let conversation_id = signal.conversation_id;
    this.updateConversation(conversation_id);


    if ( signal.play_alert_sound_for_employee_ids != null && signal.play_alert_sound_for_employee_ids.includes(this.$state.employee_id) )
    {
        this.playSound();
    }

    if ( signal.show_silent_notification != null )
    {
        this.$emit('show-message-alert',{
            'endpoint': signal.for_endpoint,
            'conversation_id': signal.conversation_id,
            'show_silent_notification': signal.show_silent_notification
        });
    }

    /* EXAMPLE
    {
        "signal_type" : "endpoint-new-message-in-conversation",
        "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
        "for_endpoint" : "E164:+16022231449",
        "conversation_id" : "4ac3b1bd-0322-4693-86ae-9f1ff27668c9",
        "play_alert_sound" : false
        "show_silent_notification" : "Some Notification"
    }
    */
}

RedChirp.prototype.onSignalUpdateConversationSummary = function(signal)
{
    this.updateOneConversationSummary(signal.for_endpoint, signal.conversation_id);

    /* EXAMPLE
    {
        "signal_type" : "endpoint-update-conversation-summary",
        "organization_id" : "8a732595-6621-4d6d-af37-0819110ae721",
        "for_endpoint" : "E164:+16022231449",
        "conversation_id" : "69d8cc69-b460-4b32-be82-5683a76c5920",
        "conversation_summary_id" : "b5fb4c5c-12b1-424c-8b3a-5aa6d596b1c1"
    }
    */
}

RedChirp.prototype.getAdHocDND = function(employee_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'employees/ad-hoc-dnd/' + employee_id,
        'method' : 'get',
        'data' : employee_id,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.putAdHocDND = function(ad_hoc_dnd_info, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'employees/ad-hoc-dnd',
        'method' : 'post',
        'data' : ad_hoc_dnd_info,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.exitAdHocDND = function(info, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'employees/ad-hoc-dnd/end-all/' + info.employee_id,
        'method' : 'post',
        'data' : info,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.runDNDNoticeProcessor = function(onSuccess, onError)
{
    this.$state.checkSignedIn();

   
    this.makeApiCall({
        'url' : 'admin/process-dnd-notices',
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseRunDNDNoticeProcessor',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.onResponseRunDNDNoticeProcessor = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success(response.response_data.room_url);
    }
    else if ( params.on_error != null )
    {
        params.on_error(response.message);
        return;
    }

    this.handleResponseBackstop(response);
}

RedChirp.prototype.onResponseAdminGetCacheStats = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success(response.response_data.stats);
    }
    else if ( params.on_error != null )
    {
        params.on_error(response.message);
        return;
    }

    this.handleResponseBackstop(response);
}


RedChirp.prototype.onResponseStartVideoChat = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success(response.response_data.room_url);
    }
    else if ( params.on_error != null )
    {
        params.on_error(response.message);
        return;
    }

    this.handleResponseBackstop(response);
}

RedChirp.prototype.sendMessage = function(to_send)
{
    this.$state.checkSignedIn();

    let active_endpoint = to_send.active_endpoint;
    let conversation_id = to_send.conversation_id;
    let text = to_send.text;
    let blob_ids = to_send.blob_ids;
    let send_images_as_links = to_send.send_images_as_links;

    if ( to_send.send_images_as_links == null ) to_send.send_images_as_links = false;
    if ( to_send.blob_ids == null ) to_send.blob_ids = '';
    
    if ( Preconditions.isArray(to_send.blob_ids) )
    {
        let tmp = '';

        for ( let i = 0; i < to_send.blob_ids.length; i++ )
        {
            tmp += '; '+to_send.blob_ids[i];
        }

        to_send.blob_ids = tmp;
    }

    to_send.from = to_send.active_endpoint;
    to_send.active_endpoint = null;

    this.makeApiCall({
        'url' : 'messages/send-message',
        'method' : 'post',
        'data' : to_send,
        'on_response' : 'onResponseSendMessage',
    });
}

RedChirp.prototype.onResponseSendMessage = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response != null && response.http_status_code === 200 )
    {
        if ( params.on_success != null ) 
            params.on_success(response.response_data);

        let conversation_id = response.response_data.conversation_summary.conversation_id;
        this.updateConversation(conversation_id);

        return;
    }
    else if ( params.on_error != null )
    {
        params.on_error();
        return;
    }

    this.handleResponseBackstop(response);
}

RedChirp.prototype.checkUptime = function(service, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'public/uptime/check-uptime-'+service,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}


RedChirp.prototype.getOtherConversations = function(conversation_id, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'conversations/other-conversations/'+conversation_id,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}


RedChirp.prototype.getOtherConversationsByEndpoint = function(organization_id, endpoint, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'conversations/other-conversations-by-endpoint/'+organization_id+'/'+endpoint,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.patchOrganizationFeatures = function(patch, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'organizations/features',
        'method' : 'patch',
        'data' : patch,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.simulateDowntime = function(service, down, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'admin/uptime/'+service,
        'method' : down ? 'down' : 'up',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.resendMessage = function(stored_message_id, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'messages/'+stored_message_id,
        'method' : 'resend',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}


RedChirp.prototype.getInboxContactRequestProfile = function(contact_request_id, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'contact-requests/inbox-contact-requests/' + contact_request_id,
        'method' : 'get',
        'data' : contact_request_id,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.getContactRequestConversationLink = function(contact_request_id, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'contact-requests/conversation-link/'+contact_request_id,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.getEmployeeSelectorOptions = function(organization_id, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'organizations/employee-selector-options/'+organization_id,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.rebuildSearch = function(perm_rebuild, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'admin/rebuild-search-records',
        'method' : perm_rebuild ? 'do' : 'get',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}



RedChirp.prototype.sendMessageToStartChat = function(active_endpoint, to, text, onSuccess, onError)
{
    this.$state.checkSignedIn();
    Preconditions.checkString(active_endpoint);
    Preconditions.checkString(to);
    Preconditions.checkString(text);

    let message_to_be_sent = {
        'organization_id': this.$state.organization_id,
        'from': active_endpoint,
        'to': [to],
        'text': text,
        'media_keys': '',
        'category' : 'conversational'
    };

    this.makeApiCall({
        'url' : 'messages/send-message',
        'method' : 'post',
        'data' : message_to_be_sent,
        'on_response' : 'onResponseSendMessage',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.mockReceive = function(from, to, text)
{
    this.$state.checkSignedIn();
    Preconditions.checkString(from);
    Preconditions.checkString(to);
    Preconditions.checkString(text);

    let message = {
        'received_on': to,
        'from': from,
        'to': [to],
        'text': text,
        'blob_ids': '',
        'time': new Date().getTime(),
    };

    this.makeApiCall({
        'url' : 'admin/mock-receive',
        'method' : 'post',
        'data' : message,
        'on_response' : 'onResponseMockReceive',
    });
}

RedChirp.prototype.onResponseMockReceive = function(response)
{
    if ( this.handleSilentOk(response) ) return;
    if ( this.handleUnauthrozied(response) ) return;

    this.handleResponseBackstop(response);
}

RedChirp.prototype.execCallbackUpdateConversationSummaries = function(summaries)
{
    this.$emit('update-conversation-summaries', summaries);
}

RedChirp.prototype.execCallbackUpdateConversation = function(conversation_id)
{
    let conversation = this.$state.cache.conversations.get(conversation_id);

    if ( Preconditions.isNull(conversation) )
    {
        return; // no such conversation;
    }

    this.$emit('update-conversation',conversation);
}

RedChirp.prototype.isSignedIn = function()
{
    return this.$state.isSignedIn();
}

RedChirp.prototype.signInAsAuthAccount = function(onSignInOk, onSignInError)
{
    this.completeSignInAs(
        this.$state.getAuthActorEmployeeId(),
        onSignInOk,
        onSignInError
    );
}

RedChirp.prototype.completeSignInAs = function(employee_id, onSignInOk, onSignInError)
{
    this.$state.clearHideSignInAsFooter();

    this.makeApiCall({
        'url' : 'auth/sign-in-as/'+employee_id,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseSignIn',
        'on_response_params' : { 'on_sign_in_ok' : onSignInOk, 'on_sign_in_error' : onSignInError }
    });
}

RedChirp.prototype.onResponseSignIn = function(response, params)
{
    if ( response != null && response.http_status_code === 200 )
    {
        // Set flag to prevent unauthorized redirects during authentication completion
        this.setAuthCompletionInProgress(true);

        // Store the profile data but avoid triggering side effects that could cause 401s
        this.$state.updateProfile(response.response_data);

        // Small delay to ensure auth token is properly set
        setTimeout(() => {
            this.setAuthCompletionInProgress(false);
            params.on_sign_in_ok();
        }, 100);
        return;
    }
    else
    {
        this.updateProfile({});

        params.on_sign_in_error(response.http_status_code);
    }
}

/**
 * Make sure the user is signed in.
 * If the user needs to sign in, they will be redirected back to the original page after.
 * 
 * @returns 
 */
RedChirp.prototype.enforceSignedIn = function(router)
{
    if (this.isSignedIn()) return;

    // Allow user to sign in and then return to this page
    localStorage.setItem('rc_after_sign_in_url', window.location);
    router.push({
        'name': 'sign-in',
    });

    return;
}



RedChirp.prototype.revokeAuth = function()
{
    this.makeApiCall({
        'url' : 'auth/revoke-auth',
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseRevokeAuth',
    });
}

RedChirp.prototype.onResponseRevokeAuth = function(response, params)
{
    if ( this.handleSilentOk(response) ) return;
    if ( this.handleUnauthrozied(response) ) return;
    this.handleResponseBackstop(response);
}

RedChirp.prototype.signOut = function()
{
    this.updateProfile({});
    this.$state.eula_check = null;
}

RedChirp.prototype.getAllEndpointConversationSummaries = function()
{
    // can't do anything, not signed in...
    if ( !this.$state.isSignedIn() ) 
        return;

    let employee_endpoints = this.$state.getEmployeeEndpoints();

    for ( let i = 0; i < employee_endpoints.length; i++ )
    {
        this.getConversationSummaries(employee_endpoints[i].endpoint, ['active'], true, true);
    }
}

RedChirp.prototype.getConversationSummaries = function(active_endpoint, include_states, include_read, include_unread, participant_state, message_content_full_text_search, message_tag_search)
{
    // can't do anything, not signed in...
    if ( !this.$state.isSignedIn() ) 
        return;

    // If here, we have an active endpoint...
    this.$state.checkSignedIn();

    if ( participant_state == null )
        participant_state = 'any';

    if ( message_tag_search != null )
    {
        if ( message_tag_search.values == null || message_tag_search.values.length == 0 )
            message_tag_search = null;
    }

    let data = {
        'endpoint': active_endpoint,
        'include_states' : include_states,
        'include_read' : include_read != null ? include_read : true,
        'include_unread' : include_unread != null ? include_unread : true,
        'participant_state' : participant_state,
        'message_content_full_text_search' : message_content_full_text_search,
        'message_tag_search': message_tag_search
    };

    // We need to fetch the convseration summaries via restful API call...
    this.makeApiCall({
        'url' : 'conversations',
        'method' : 'list',
        'data' : data,
        'on_response' : 'onResponseUpdateConversationSummaries',
        'on_response_params' : { 'endpoint' : active_endpoint },
    });
}

RedChirp.prototype.onResponseUpdateConversationSummaries = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        this.$state.upsertLabels(response.response_data.labels);

        let summaries = new ConversationSummaries(params.endpoint, response.response_data.summaries, this.$state.labels, response.response_data);
        this.$state.upsertConversationSummaries(summaries);

        this.execCallbackUpdateConversationSummaries(summaries);
        return;
    }

    this.handleResponseBackstop(response);
}

RedChirp.prototype.getEmployeeGroupEndpoint = function(employee_group_id, on_success, on_error)
{
    Preconditions.checkNotNull(employee_group_id);

    // We need to fetch the convseration summaries via restful API call...
    this.makeApiCall({
        'url' : 'organizations/employee-groups/endpoints/'+employee_group_id,
        'method' : 'list',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.listEmployeeGroupUses = function(organization_id, employee_group_id, on_success, on_error)
{
    Preconditions.checkNotNull(organization_id);
    Preconditions.checkNotNull(employee_group_id);

    // We need to fetch the convseration summaries via restful API call...
    this.makeApiCall({
        'url' : 'organizations/employee-groups/group-uses/' + organization_id + '/' + employee_group_id,
        'method' : 'list',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}



RedChirp.prototype.getConversationSummary = function(for_endpoint, conversation_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'conversation-summaries/'+for_endpoint+'/'+conversation_id,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.searchWidgetSettings = function(search, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'widget/settings',
        'method' : 'list',
        'data' : search,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.getWidgetSettings = function(settings_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'widget/settings/'+settings_id,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.patchWidgetSettings = function(patch, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'widget/settings',
        'method' : 'patch',
        'data' : patch,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.createNewWidgetSettings = function(params, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'widget/settings',
        'method' : 'create-new',
        'data' : params,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.deleteWidgetSettings = function(widget_settings_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'widget/settings/'+widget_settings_id,
        'method' : 'DELETE',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.promoteWidgetSettingsToDefault = function(widget_settings_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'widget/settings/'+widget_settings_id,
        'method' : 'PROMOTE-TO-DEFAULT',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.sendAutoMessage = function(auto_message_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'auto-messages/'+auto_message_id,
        'method' : 'send',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.cancelAutoMessage = function(auto_message_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'auto-messages/'+auto_message_id,
        'method' : 'cancel',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}




RedChirp.prototype.testMessagePatterns = function(params, on_success, on_error)
{
    this.makeApiCall({
        'url' : '/message-patterns',
        'method' : 'test',
        'data' : params,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.populateMessagePatterns = function(params, on_success, on_error)
{
    this.makeApiCall({
        'url' : '/message-patterns',
        'method' : 'populate',
        'data' : params,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.parseShipmentTrackingNumber = function(tn, on_success, on_error)
{
    this.makeApiCall({
        'url' : '/integrations/shipping/parse-tracking-number',
        'method' : 'parse',
        'data' : {'tn':tn},
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.getAutoMessageTemplateProfile = function(params, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'auto-messages/templates',
        'method' : 'get-profile',
        'data' : params,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.triggerAutoMessage = function(params, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'auto-messages',
        'method' : 'trigger',
        'data' : params,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}



RedChirp.prototype.deleteAutoMessageTemplate = function(params, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'auto-messages/templates',
        'method' : 'delete',
        'data' : params,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.putAutoMessageTemplate = function(template, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'auto-messages/templates',
        'method' : 'put',
        'data' : template,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}



RedChirp.prototype.patchCommerce7Settings = function(patch_data, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'integrations/commerce7',
        'method' : 'patch',
        'data' : patch_data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.patchVinSuiteSettings = function(patch_data, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'integrations/vinsuite',
        'method' : 'patch',
        'data' : patch_data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.updateOneConversationSummary = function(for_endpoint, conversation_id)
{
    this.makeApiCall({
        'url' : 'conversation-summaries/'+for_endpoint+'/'+conversation_id,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseUpdateOneConversationSummary',
        'on_response_params' : { 'endpoint' : for_endpoint },
    });
}

RedChirp.prototype.onResponseUpdateOneConversationSummary = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        this.$state.upsertLabels(response.response_data.labels);

        let summaries = this.$state.cache.summaries.get(params.endpoint);
        if ( summaries == null )
        {
            summaries = new ConversationSummaries(params.endpoint, response.response_data.summaries, this.$state.labels, response.response_data);
        }
        else
        {
            summaries.upsert(response.response_data.summaries, response.response_data);
        }

        this.$state.upsertConversationSummaries(summaries);
        this.execCallbackUpdateConversationSummaries(summaries);

        return;
    }

    this.handleResponseBackstop(response);
}

RedChirp.prototype.updateOneLabel = function(endpoint)
{
    this.makeApiCall({
        'url' : 'labels',
        'method' : 'list',
        'data' : [endpoint],
        'on_response' : 'onResponseUpdateOneLabel',
    });
}

RedChirp.prototype.onEmployeeNotification = function(signal)
{
    if ( this.$state.getEmployeeAccount().employee_id != signal.employee_id )
    {
        return;
    }

    this.playSound();
    this.$emit('employee-notification', signal);
}



RedChirp.prototype.onUpsertContactRequest = function(contact_request_id)
{
    this.$emit('upsert-contact-request', contact_request_id);
}

RedChirp.prototype.onBlobMetaDataUpdate = function(event)
{
    this.$emit('update-blob-meta-data', event);
}

RedChirp.prototype.onResponseUpdateOneLabel = function(response)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        this.$state.upsertLabels(response.response_data.labels);

        let employee_endpoints = this.$state.getEmployeeEndpoints();
        for ( let i = 0; i < employee_endpoints.length; i++ )
        {
            let cur_endpoint = employee_endpoints[i].endpoint;            
            let cur_summaries = this.$state.cache.summaries.get(cur_endpoint);
            if ( cur_summaries == null ) continue;
            
            this.execCallbackUpdateConversationSummaries(cur_summaries);
        }

        return;
    }

    this.handleResponseBackstop(response);
}



// TIP: used encodeURIComponent to encode the components of the query_string
RedChirp.prototype.searchTable = function(table_path, query_string, onSuccess, onError)
{
    // We need to fetch the convseration summaries via restful API call...

    this.makeApiCall({
        'url' : table_path+"?"+query_string,
        'method' : 'list',
        'data' : null,
        'on_response' : 'onResponseSearchTable',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.onResponseSearchTable = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        params.on_success(response.response_data);
        return;
    }

    if ( params.on_error != null )
    {
        params.on_error();
        return;
    }

    this.handleResponseBackstop(response);
}

RedChirp.prototype.getBlobEndpoint = function(blob_meta_data)
{
    if ( blob_meta_data != null && blob_meta_data.data.purpose == 'red-chirp-crm-note-attachment' )
    {
        return this.getSignedInOnlyBlobUrl(blob_meta_data.data.object_name);
    }

    let object_name = blob_meta_data.getObjectName();
    
    if ( object_name == null )
        object_name = blob_meta_data.getBlobId();

    return 'https://files.redchirp.com/'+object_name;
}

RedChirp.prototype.blobURL = function(blob_object_name)
{
    return 'https://files.redchirp.com/'+blob_object_name;
}

RedChirp.prototype.openBlob = function(blob_object_name)
{
    window.open(this.blobURL(blob_object_name),"_blank");
}

RedChirp.prototype.uploadBlob = function(file, purpose, process_media, afterUpload, uploadProgress, organization_id, extra_blob_meta)
{
    let blob_meta_data = {
        'purpose': purpose,
        'label': file.name,
        'process_media' : process_media,
        'organization_id' : organization_id
    };

    if (extra_blob_meta && typeof extra_blob_meta === 'object') {
        for (const k in extra_blob_meta) {
            if (Object.prototype.hasOwnProperty.call(extra_blob_meta, k) && extra_blob_meta[k] != null) {
                blob_meta_data[k] = extra_blob_meta[k];
            }
        }
    }

    var formData = new FormData();
    formData.append("blob_file", file);
    formData.append("blob_meta_data", JSON.stringify(blob_meta_data));

    this.makeApiCall({
        'url' : 'blobs/'+uuidv4(),
        'method' : 'put',
        'form_data' : formData,
        'on_response' : 'onResponseUploadBlob',
        'on_response_params' : { 'call_back' : afterUpload },
        'on_upload_progress': uploadProgress,
        'force_ngrok_in_dev' : false, // to slow the upload so the progress bar works...
        'timeout' : -1,
    });
}

RedChirp.prototype.onResponseUploadBlob = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        let meta_data = new BlobMetaData(response.response_data.meta_data);
        
        params.call_back(meta_data);

        return meta_data;
    }

    this.handleResponseBackstop(response);
}

RedChirp.prototype.patchBlob = function(meta_data, new_is_archived, new_label, new_industry_codes, afterPatch)
{
    let data = {};
    if (new_is_archived !== null && new_is_archived !== undefined) {
        data.is_archived = new_is_archived;
    }
    if (new_label !== null && new_label !== undefined) {
        data.new_label = new_label;
    }
    if (new_industry_codes !== undefined) {
        if (Array.isArray(new_industry_codes)) {
            data.new_industry_codes = new_industry_codes;
        } else if (new_industry_codes === null) {
            data.new_industry_codes = [];
        } 
    }

    this.makeApiCall({
        'url' : 'blobs/'+meta_data.getBlobId(),
        'method' : 'patch',
        'data' : data,
        'on_response' : 'onResponsePatchBlob',
        'on_response_params' : { 'call_back' : afterPatch },
    });
}

RedChirp.prototype.onResponsePatchBlob = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        let meta_data = new BlobMetaData(response.response_data.meta_data);
        
        params.call_back(meta_data);

        return meta_data;
    }

    this.handleResponseBackstop(response);
}


RedChirp.prototype.upsertLabel = function(endpoint, label)
{
    let label_to_upsert = {
        'account_id' : this.getOrganizationAccount().account_id,
        'endpoint' : endpoint,
        'label' : label,
     };

    this.makeApiCall({
        'url' : 'labels/upsert-label',
        'method' : 'post',
        'data' : label_to_upsert,
        'on_response' : 'onResponseUpsertLabel',
    });
}

RedChirp.prototype.onResponseUpsertLabel = function(response, params)
{
    if ( this.handleSilentOk(response) ) return;
    if ( this.handleUnauthrozied(response) ) return;

    this.handleResponseBackstop(response);
}

RedChirp.prototype.setConversationRead = function(active_endpoint, conversation_id, new_read_value)
{
    this.makeApiCall({
        'url' : 'conversation-summaries/'+active_endpoint+'/'+conversation_id+'/set-read?read='+new_read_value,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseSetConversationRead',
    });
}

RedChirp.prototype.onResponseSetConversationRead = function(response)
{
    if ( this.handleSilentOk(response) ) return;
    if ( this.handleSilentNotFound(response) ) return;
    if ( this.handleUnauthrozied(response) ) return;

    this.handleResponseBackstop(response);
}

RedChirp.prototype.setConversationIsTyping = function(for_endpoint, conversation_id, employee_contact, is_typing_value)
{
    let label = employee_contact.label;

    if ( label == null )
    {
        label = employee_contact.name.first + ' ' + employee_contact.name.last;
    }

    let signal = {
        'organization_id' : employee_contact.organization_id,
        'for_endpoint' : for_endpoint,
        'conversation_id' : conversation_id,
        'employee_id' : employee_contact.of_employee_id,
        'employee_label' : label,
        'is_typing' : is_typing_value,
    };

    this.makeApiCall({
        'url' : 'conversations/is-typing',
        'method' : 'put',
        'data' : signal,
        'on_response' : 'onResponseStandardSilentError',
    });
}



RedChirp.prototype.setContactRequestIsTyping = function(organization_id, contact_request_id, employee_info, is_typing_value)
{
    let label = employee_info.label;

    if ( label == null )
    {
        label = employee_info.name.first + ' ' + employee_info.name.last;
    }

    let signal = {
        'signal_type' : 'common-contact-request-is-typing',
        'organization_id' : organization_id,
        'contact_request_id' : contact_request_id,
        'employee_id' : employee_info.of_employee_id,
        'employee_label' : label,
        'is_typing' : is_typing_value,
    };

    this.makeApiCall({
        'url' : 'contact-requests/is-typing',
        'method' : 'put',
        'data' : signal,
        'on_response' : 'onResponseStandard',
    });
}

RedChirp.prototype.onResponseSetConversationArchived = function(response)
{
    if ( this.handleSilentOk(response) ) return;
    if ( this.handleUnauthrozied(response) ) return;

    this.handleResponseBackstop(response);
}


RedChirp.prototype.getConversation = function(conversation_id)
{
    Preconditions.checkString(conversation_id);
    this.$state.checkSignedIn();

    let conversation = this.$state.cache.conversations.get(conversation_id);

    if ( !Preconditions.isNull(conversation) )
    {
        this.execCallbackUpdateConversation(conversation_id);
        return;
    }

    return this.updateConversation(conversation_id);
}

RedChirp.prototype.updateConversation = function(conversation_id, offset, limit)
{
    Preconditions.checkString(conversation_id);

    if ( offset == null ) offset = 0;
    if ( limit == null ) limit = 100;

    // We need to fetch the convseration summaries via restful API call...
    var url = this.getAPIEndpoint('conversations/'+conversation_id);

    this.makeApiCall({
        'url' : 'conversations/'+conversation_id+'?offset='+offset+"&limit="+limit,
        'method' : 'list',
        'data' : null,
        'on_response' : 'onResponseUpdateConversation',
        'on_response_params' : { 'conversation_id' : conversation_id },
    });
}

RedChirp.prototype.onResponseUpdateConversation = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code == 404 )
    {
        this.$emit('conversation-not-found');
        return;
    }

    if ( response.http_status_code === 200 )
    {
        let conversation = new Conversation(response.response_data);

        this.$state.upsertLabels(response.response_data.labels);
        this.$state.upsertConversation(conversation);

        this.execCallbackUpdateConversation(params.conversation_id);

        return conversation;
    }

    this.handleResponseBackstop(response);
}

RedChirp.prototype.immediatePromise = function(value)
{
    return new Promise(
        function(resolve,reject)
        {
            resolve(value);
        }
    );
}





RedChirp.prototype.normalizeIntervals = function(intervals, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'time/normalize-intervals',
        'method' : 'post',
        'data' : intervals,
        'on_response' : 'onNormalizeIntervalsResponse',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.onNormalizeIntervalsResponse = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response != null && response.http_status_code === 200 )
    {
        params.on_success(response.response_data.normalized);
    }
    else
    {
        if ( params.on_error != null )
        {
            params.on_error();
            return;
        }
    }

    this.handleResponseBackstop(response);
}

RedChirp.prototype.makeTestAPICall = function(http_status_code, message, onResponseReceived)
{
    let front_end_error = false;
    // Trigger an error in the response handler
    if ( http_status_code == 420 )
    {
        http_status_code = 200;
        front_end_error = true;
    }

    this.makeApiCall({
        'url' : 'test/test-json-response',
        'method' : 'post',
        'data' : { 
            'code' : http_status_code,
            'message' : message,
        },
        'on_response' : 'onTestAPICallResponse',
        'on_response_params' : { 'client_callback' : onResponseReceived, 'front_end_error' : front_end_error },
    });
}

RedChirp.prototype.onTestAPICallResponse = function(response, params)
{
    if ( params.front_end_error )
    {
        this.some_function_that_will_never_exist();
    }

    params.client_callback(response);

    if ( this.handleSilentOk(response) ) return;
    if ( this.handleUnauthrozied(response) ) return;

    this.handleResponseBackstop(response);
}

RedChirp.prototype.testHTTPLoopback = function(on_success, on_error)
{
    this.makeApiCall({
        'url' : 'test/test-loopback-http',
        'method' : 'get',
        'on_response' : 'testHTTPLoopbackResponse',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.testHTTPLoopbackResponse = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success(response.response_data);
    }
    else if ( params.on_error != null )
    {
        params.on_error();
        return;
    }

    this.handleResponseBackstop(response);
}



RedChirp.prototype.searchBlobMetaDataSummaries = function(search, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'blobs/search',
        'method' : 'list',
        'data' : search,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}





RedChirp.prototype.adminNewStoredMessage = function(data, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'admin/stored-message',
        'method' : 'put',
        'data' : data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.newGetConversation = function(conversation_id, def_only, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'conversations-new/'+conversation_id,
        'method' : def_only ? "GET_DEFINITION" : "GET",
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}


RedChirp.prototype.getValidEncoders = function(on_success, on_error)
{
    this.makeApiCall({
        'url' : 'blobs/supported-codecs',
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.adminSearchOrganizations = function(search, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'admin/organizations/search',
        'method' : 'list',
        'data' : search,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}


RedChirp.prototype.getBlobMetaDataMultiple = function(blob_ids, on_success, on_error)
{
    if ( blob_ids == null || blob_ids.length == 0 )
    {
        if ( on_success != null ) 
            on_success({ 'meta_data' : [] });

        return;
    }

    this.makeApiCall({
        'url' : 'blobs',
        'method' : 'get_metadata',
        'data' : blob_ids,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.upsertLocation = function(location, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'locations',
        'method' : 'post',
        'data' : location,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.sendTestNotification = function(type, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'test/employee-notification',
        'method' : 'post',
        'data' : {'type' : type},
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.getDefaultNewLocationForOrganization = function(organization_id, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'locations/default-new-values-for-organization/'+organization_id,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.postCampaignRegistrySettings = function(settings, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'organizations/campaign-registry-settings',
        'method' : 'post',
        'data' : settings,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.parseInterval = function(text, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'time/parse-interval',
        'method' : 'post',
        'data' : { 'text' : text },
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.getFollowConversationInformation = function(conversation_id, endpoint, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'conversations/follow',
        'method' : 'get-info',
        'data' : { 'conversation_id' : conversation_id, 'endpoint' : endpoint },
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.followConversation = function(params, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'conversations/follow',
        'method' : 'put',
        'data' : params,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.getEmployeeFollowingInfo = function(employee_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'employees/following-info/'+employee_id,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.followEndpoint = function(params, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'endpoint/follow',
        'method' : 'put',
        'data' : params,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.assignRedChirpPhoneNumbers = function(post_data, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'numbers/assign-numbers',
        'method' : 'post',
        'data' : post_data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.searchOrganizationLabels = function(search, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'organizations/labels',
        'method' : 'list',
        'data' : search,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.searchCountryAndSubdivisionFullText = function(search_params, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'concepts/iso3166/search-country-subdivision',
        'method' : 'list',
        'data' : search_params,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.searchPayments = function(search, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'payments',
        'method' : 'list',
        'data' : search,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}



RedChirp.prototype.getContact = function(contact_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'contacts/' + contact_id,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.searchPickupStatus = function(search, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'pickups/pickup-status',
        'method' : 'list',
        'data' : search,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.searchLocations = function(search, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'locations',
        'method' : 'list',
        'data' : search,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.upsertPickup = function(pickup, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'pickups',
        'method' : 'post',
        'data' : pickup,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.getPickupEvents = function(pickup_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'pickups/'+pickup_id,
        'method' : 'list-events',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.getPickup = function(pickup_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'pickups/'+pickup_id,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.pickupAction = function(action, params, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'pickups',
        'method' : action,
        'data' : params,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}


RedChirp.prototype.listBulkOptOutEvents = function(organization_id, endpoint, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'bulk/opt-outs/events/'+organization_id+'/'+endpoint,
        'method' : 'list',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}


RedChirp.prototype.searchTeamNumbers = function(search, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'teams/list',
        'method' : 'list',
        'data' : search,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.searchTeamNumbers = function(search, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'teams/list',
        'method' : 'list',
        'data' : search,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.listBulkMessages = function(bulk_message_search, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'bulk/messages/search',
        'method' : 'list',
        'data' : bulk_message_search,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.getBulkMessageSendingStatus = function(organization_id, bulk_message_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'bulk/messages/send-status/' + organization_id + '/' + bulk_message_id,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
        'timeout' : 45000
    });
}

RedChirp.prototype.getBulkMessageOutcomesFromRecipientId = function(bulk_recipient_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'bulk/messages/outcomes/from-recipient-id/' + bulk_recipient_id,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.putBulkMessage = function(data, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'bulk/messages/put',
        'method' : 'put',
        'data' : data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.checkBulkMessageText = function(organization_id, message, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'bulk/messages/check-text/' + organization_id,
        'method' : 'put',
        'data' : message,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.patchBulkMessage = function(bulk_message_id, changes, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'bulk/messages/patch/' + bulk_message_id,
        'method' : 'put',
        'data' : changes,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.listBuiltInRateCards = function(on_success, on_error)
{
    this.makeApiCall({
        'url' : 'billing/built-in/rate-card',
        'method' : 'list',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.listBuiltInRateCardLines = function(search, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'billing/built-in/rate-card-lines',
        'method' : 'list',
        'data' : search,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}



RedChirp.prototype.getIntuitToken = function(realm_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'integrations/intuit/tokens',
        'method' : 'list',
        'data' : {'realm_id' : realm_id},
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.putIntuitToken = function(post_data, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'integrations/intuit/tokens',
        'method' : 'put',
        'data' : post_data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}



RedChirp.prototype.listOrganizationRateCards = function(post_data, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'billing/organization',
        'method' : 'list',
        'data' : post_data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}






RedChirp.prototype.startExcelExportBulkPreviewRecipients = function(organization_id, import_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'bulk/recipients/preview/export/' + organization_id + '/' + import_id,
        'method' : 'export',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.updateBulkRecipientOutcome = function(recipient_id, outcome_id, on_success, on_error)
{
    Preconditions.checkNotNull(recipient_id);

    let data = {
        'outcome_id' : outcome_id,
    };

    this.makeApiCall({
        'url' : 'bulk/recipients/change-outcome/' + recipient_id,
        'method' : 'put',
        'data' : data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.updateBulkRecipientCustomMessage = function(recipient_id, custom_message, on_success, on_error)
{
    Preconditions.checkNotNull(recipient_id);

    let data = {
        'custom_message' : custom_message,
    };

    this.makeApiCall({
        'url' : 'bulk/recipients/custom-message/' + recipient_id,
        'method' : 'put',
        'data' : data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.putBulkMessageRecipient = function(data, on_success, on_error)
{
    Preconditions.checkNotNull(data);

    this.makeApiCall({
        'url' : 'bulk/recipients/put',
        'method' : 'put',
        'data' : data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.deleteBulkMessageRecipient = function(bulk_recipient_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'bulk/recipients/' + bulk_recipient_id,
        'method' : 'delete',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.deleteBulkMessageRecipients = function(search, on_success, on_error)
{
    Preconditions.checkNotNull(search);

    this.makeApiCall({
        'url' : 'bulk/recipients/delete',
        'method' : 'delete',
        'data' : search,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.listBulkMessageOutcomes = function(search, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'bulk/messages/outcomes',
        'method' : 'list',
        'data' : search,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.getConversationFromBulkRecipient = function(conversation_id, recipient_endpoint, on_success, on_error)
{
    Preconditions.checkNotNull(conversation_id);
    Preconditions.checkNotNull(recipient_endpoint);

    let data = {
        'recipient_endpoint' : recipient_endpoint
    };

    this.makeApiCall({
        'url' : 'bulk/recipients/get-conversation/' + conversation_id,
        'method' : 'post',
        'data' : data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.upsertBulkMessageOutcome = function(bulk_message_outcome, on_success, on_error)
{
    Preconditions.checkNotNull(bulk_message_outcome);

    this.makeApiCall({
        'url' : 'bulk/messages/outcome/' + bulk_message_outcome.outcome_id,
        'method' : 'put',
        'data' : bulk_message_outcome,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}



RedChirp.prototype.bulkRecipientsCommitIntermediate = function(organization_id, bulk_message_id, intermediate_recipients, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'bulk/recipients/commit-recipients/' + organization_id + '/' + bulk_message_id,
        'method' : 'put',
        'data' : intermediate_recipients,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.uploadBulkRecipientExcelFile = function(organization_id, import_id, excel_file, bulk_message_id, on_success, on_error)
{
    let form_data = new FormData();
    form_data.append('recipients_src', excel_file);
    form_data.append('bulk_message_id', bulk_message_id);
    form_data.append('label', excel_file.name);

    this.makeApiCall({
        'url' : 'bulk/recipients/upload-excel/' + organization_id + '/' + import_id,
        'method' : 'put',
        'form_data' : form_data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
        'timeout': 30*60000, // 30 minutes
    });
}

RedChirp.prototype.listBulkRecipientImportInfo = function(organization_id, import_id, sheet_name, has_header_row, on_success, on_error)
{
    let data = {
        'organization_id' : organization_id,
        'import_id' : import_id,
        'sheet_selected' : sheet_name,
        'has_header_row' : has_header_row,
    };

    this.makeApiCall({
        'url' : 'bulk/recipients/excel-import-info',
        'method' : 'list',
        'data' : data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
        'timeout': 30*60000, // 30 minutes
    });
}

RedChirp.prototype.getBulkRecipientImport = function(organization_id, import_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'bulk/recipients/excel-import/' + organization_id + '/' + import_id,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.upsertRecipientsExcelWorksheet = function(organization_id, import_id, excel_worksheet, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'bulk/recipients/excel-worksheet/' + organization_id + '/' + import_id,
        'method' : 'put',
        'data' : excel_worksheet,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}



RedChirp.prototype.phoneNumbersValidate = function(endpoints, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'phone_numbers/validate',
        'method' : 'put',
        'data' : endpoints,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.updateBulkRecipientPhoneNumberValidation = function(organization_id, import_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'bulk/recipients/validate-endpoints/' + organization_id + '/' + import_id,
        'method' : 'update',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.updateBulkRecipientPhoneNumberValidationBandwidth = function(organization_id, import_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'bulk/recipients/validate-endpoints-bandwidth/' + organization_id + '/' + import_id,
        'method' : 'update',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.updateContinueBulkRecipientEndpointValidation = function(organization_id, import_id, batch_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'bulk/recipients/continue-validate-endpoints/' + organization_id + '/' + import_id + '/' + batch_id,
        'method' : 'update',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.updateForceBulkRecipientNumberValidation = function(organization_id, import_id, exclude_unvalidated, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'bulk/recipients/force-validate-endpoints/' + organization_id + '/' + import_id + '/exclude-unvalidated?exclude='+exclude_unvalidated,
        'method' : 'update',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}



// end bulk messaging functions

// saved message functions
RedChirp.prototype.searchSavedMessages = function(search, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'saved-messages',
        'method' : 'list',
        'data' : search,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.putSavedMessage = function(saved_message, on_success, on_error)
{
    Preconditions.checkNotNull(saved_message);

    this.makeApiCall({
        'url' : 'saved-messages',
        'method' : 'put',
        'data' : saved_message,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.deleteSavedMessage = function(organization_id, saved_message_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'saved-messages/' + organization_id + '/' + saved_message_id,
        'method' : 'delete',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.instantiateSavedMessage = function(organization_id, saved_message_id, conversation_id, for_endpoint, on_success, on_error)
{
    let data = {
        'organization_id' : organization_id,
        'saved_message_id' : saved_message_id,
        'conversation_id' : conversation_id,
        'for_endpoint' : for_endpoint,
    };

    this.makeApiCall({
        'url' : 'saved-messages/instantiate',
        'method' : 'put',
        'data' : data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.instantiateSavedMessageFromContactRequest = function(saved_message_id, contact_request_id, on_success, on_error)
{
    let data = {
        'saved_message_id' : saved_message_id,
        'contact_request_id' : contact_request_id,
    };

    this.makeApiCall({
        'url' : 'saved-messages/instantiate-from-contact-request',
        'method' : 'put',
        'data' : data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.previewSavedMessage = function(content, on_success, on_error)
{
    Preconditions.checkNotNull(content);

    let data = {
        'content' : content,
    };

    this.makeApiCall({
        'url' : 'saved-messages/preview',
        'method' : 'put',
        'data' : data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

// end saved message functions

RedChirp.prototype.getPayment = function(payment_id, method, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'payments/'+payment_id,
        'method' : method,
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}


RedChirp.prototype.processPayment = function(payment_id, post_data, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'payments/'+payment_id,
        'method' : 'process',
        'data' : post_data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.providePayment = function(payment_id, post_data, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'payments/'+payment_id,
        'method' : 'provide',
        'data' : post_data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}



RedChirp.prototype.voidPayment = function(payment_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'payments/'+payment_id,
        'method' : 'void',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.searchPhoneNumbersFullText = function(search_params, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'organizations/contacts/search-phone-numbers',
        'method' : 'list',
        'data' : search_params,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}


RedChirp.prototype.adminFrontEndLinkToConversation = function(endpoint, conversation_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'admin/front-end-link-to-conversation',
        'method' : 'post',
        'data' : { 'endpoint' : endpoint, 'conversation_id' : conversation_id },
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.searchWidgetAnalytics = function(search, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'widget/analytics',
        'method' : 'list',
        'data' : search,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.flushWidgetAnalytics = function(on_success, on_error)
{
    this.makeApiCall({
        'url' : 'widget/analytics',
        'method' : 'flush',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}


RedChirp.prototype.searchEmployeeLabels = function(search, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'organizations/employees/labels',
        'method' : 'list',
        'data' : search,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.searchConversationLabels = function(search, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'conversations',
        'method' : 'list-labels',
        'data' : search,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}


RedChirp.prototype.createEmployeeContactRequest = function(request_data, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'contact-requests/create-employee-contact-request',
        'method' : 'put',
        'data' : request_data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.searchOpenContactRequests = function(employee_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'contact-requests/open/'+employee_id,
        'method' : 'list',
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.getFlatConversation = function(conversation_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'conversations/flat/'+conversation_id,
        'method' : 'get',
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.getRestAPIEnvironment = function(on_success, on_error)
{
    this.makeApiCall({
        'url' : 'public/get-environment',
        'method' : 'get',
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.getOrCreateConversationDefinition = function(params, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'conversations/get-conversation-id',
        'method' : 'post',
        'data' : params,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.getConversationLabel = function(params, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'conversations/get-label',
        'method' : 'post',
        'data' : params,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.getBlobMetaData = function(blob_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'blobs/'+blob_id,
        'method' : 'get_metadata',
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}


RedChirp.prototype.getTeamNumberVoiceSettings = function(organization_id, endpoint, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'numbers/team/voice-settings/'+organization_id+'/'+endpoint,
        'method' : 'get',
        'data': null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.putTeamNumberVoiceSettings = function(settings, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'numbers/team/voice-settings',
        'method' : 'put',
        'data': settings,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.getBannerBranding = function(organization_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'branding/banner/'+organization_id,
        'method' : 'get',
        'data': null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.putBannerBranding = function(settings, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'branding/banner',
        'method' : 'put',
        'data': settings,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}


RedChirp.prototype.upsertVoicemailSettings = function(new_settings, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'employees/settings/voicemail',
        'method' : 'post',
        'data' : new_settings,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.onResponseStandard = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;
    
    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success(response.response_data);
    }
    else if ( params.on_error != null )
    {
        params.on_error(response);
        return;
    }

    this.handleResponseBackstop(response);
}

RedChirp.prototype.onResponseStandardSilentError = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;
    
    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success(response.response_data);
    }
    else if ( params.on_error != null )
    {
        params.on_error();
        return;
    }
}

RedChirp.prototype.deleteCurrentEulaSignature = function(employee_id, on_success, on_error)
{
    this.$state.eula_check = null; // reset the cache (for testing EULA purposes...)

    this.makeApiCall({
        'url' : 'eula/signatures/'+employee_id,
        'method' : 'delete_current',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.getOrganizationLabel = function(organization_id, on_success)
{
    let search = {
        'organization_id' : organization_id,
    };

    this.searchOrganizationLabels(
        search,

        (results) => {
            
            if ( results.results.length != 0 )
                on_success(results.results[0].label);
            else
                on_success('Unknown Organization');
        },

        () => {
            on_success('Unknown Organization');
        }
    );
}

RedChirp.prototype.checkEULA = function(on_success, on_error)
{
    if ( this.$state.eula_check != null )
    {
        let eula_check = this.$state.eula_check;

        if ( Date.now() - eula_check.check_time < 86400000 )
        {
            if ( eula_check.signature_current == true )
            {
                on_success(eula_check);
                return;
            }
        }
    }

    this.$state.eula_check = null;

    this.rest({
        'spinner': false,
        'endpoint': 'GET: /api/v1/eula/signatures/:employee_id',
    
        'params' : {
                'employee_id': this.$state.employee_id,
            },
    
        'on_success': (eula_check) => {
                eula_check.check_time = Date.now();
                this.$state.eula_check = eula_check;
                
                on_success(eula_check);
            },
    
        'on_error': () => {
            on_error();
        }
    });

  
}

RedChirp.prototype.getEulaSignature = function(employee_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'eula/signatures/'+employee_id,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}


RedChirp.prototype.onValidateAuth = function(after_validate)
{
    this.makeApiCall({
        'url' : 'auth/validate',
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseRevalidateAuth',
        'on_response_params' : { 'on_success' : after_validate }
    });
}

RedChirp.prototype.onResponseRevalidateAuth = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response != null && response.http_status_code === 200 )
    {
        this.updateProfile(response.response_data);
        if ( params.on_success != null )
            params.on_success();

        return;
    }
    
    this.handleResponseBackstop(response);
}

RedChirp.prototype.getEmployeeProfile = function(employee_id, onSuccess, onError)
{
    Preconditions.checkString(employee_id);
    
    this.makeApiCall({
        'url' : 'employees/'+employee_id,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseGetEmployeeProfile',
        'on_response_params' : { 'employee_id' : employee_id, 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.updateInstalledApps = function()
{
    let employee_id = this.$state.getEmployeeId();

    if ( employee_id == null )
        return;

    this.getEmployeeProfile(
        employee_id,
        (profile) => {
            this.$state.updateInstalledApps(profile.installed_apps);
        },
        () => {

        }
    )
}

RedChirp.prototype.onResponseGetEmployeeProfile = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success(response.response_data);
    }
    else if ( params.on_error != null )
    {
        params.on_error();
        return;
    }

    this.handleResponseBackstop(response);
}



RedChirp.prototype.getContactByEndpoint = function(endpoint, onSuccess)
{
    Preconditions.checkString(endpoint);
    
    this.makeApiCall({
        'url' : 'contacts/by-endpoint/'+this.$state.organization_id+'/'+endpoint+"?create_if_needed=true",
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseGetContactByEndpoint',
        'on_response_params' : { 'employee_id' : endpoint, 'on_success' : onSuccess },
    });
}

RedChirp.prototype.onResponseGetContactByEndpoint = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success(response.response_data.contact);
    }

    this.handleResponseBackstop(response);
}

RedChirp.prototype.putImportVCard = function(organization_id, vcard_data, onSuccess, onError)
{
    Preconditions.checkNotNull(organization_id);
    Preconditions.checkNotNull(vcard_data);

    this.makeApiCall({
        'url' : 'contacts/import-vcard/' + organization_id,
        'method' : 'put',
        'data' : vcard_data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.deleteContact = function(contact, onSuccess, onError)
{
    Preconditions.checkNotNull(contact);
    
    this.makeApiCall({
        'url' : 'contacts/' + contact.contact_id,
        'method' : 'delete',
        'data' : contact,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.upsertContact = function(contact, onSuccess)
{
    Preconditions.checkNotNull(contact);
    
    this.makeApiCall({
        'url' : 'contacts',
        'method' : 'put',
        'data' : contact,
        'on_response' : 'onResponseUpsertContact',
        'on_response_params' : { 'on_success' : onSuccess },
    });
}

RedChirp.prototype.onResponseUpsertContact = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code == 200 )
    {
        if ( params.on_success != null )
            params.on_success();

        return;
    }

    this.handleResponseBackstop(response);
}


RedChirp.prototype.getOrganizationProfile = function(organization_id, onSuccess, onError)
{
    Preconditions.checkNotNull(organization_id);
    
    this.makeApiCall({
        'url' : 'organizations/profile/'+organization_id,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseGetOrganizationProfile',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.isAppInstalled = function(app_id)
{
    if (!app_id) return false;

    app_id = this.resolveAppName(app_id);

    let installed_apps = this.$state.profile.installed_apps;

    if ( installed_apps == null )
        return false;

    return installed_apps.some(item => item.app_id.toLowerCase() == app_id);
}

RedChirp.prototype.resolveAppName = function(app_id_or_name)
{
    if (!app_id_or_name) return null;
    
    let app_id = app_id_or_name;
    
    app_id = app_id.toLowerCase();

    // Replace an app name (code) with the UUID
    enum_data.app_special_id.forEach(item => {
        if ( item.value == app_id ) 
            app_id = item.app_id.toLowerCase();
    });

    return app_id;
}

RedChirp.prototype.getAppLabelFromValue = function(app_value)
{
    if (!app_value) return null;

    let resolved_label = app_value;

    resolved_label = resolved_label.toLowerCase();
    let return_val = '';

    enum_data.app_special_id.forEach(item => {
        if ( item.value == resolved_label ) 
            return_val = item.text;
    });

    return return_val;
}

RedChirp.prototype.getAppLabelFromId = function(app_id)
{
    if (!app_id) return null;

    let resolved_label = app_id;

    resolved_label = resolved_label.toLowerCase();
    let return_val = '';

    enum_data.app_special_id.forEach(item => {
        if ( item.app_id == resolved_label ) 
            return_val = item.text;
    });

    return return_val;
}

RedChirp.prototype.onResponseGetOrganizationProfile = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success(response.response_data.profile, response.response_data.pixel_code);
    }
    else if ( params.on_error != null )
    {
        params.on_error(response.response_data);
        return;
    }

    this.handleResponseBackstop(response);
}

RedChirp.prototype.getWidgetCode = function(onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'public/widget-code',
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.getContactRequest = function(contact_request_id, onSuccess, onError)
{
    Preconditions.checkNotNull(contact_request_id);
    
    this.makeApiCall({
        'url' : 'contact-requests/'+contact_request_id,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseGetContactRequest',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.markContactRequestAsSpam = function(contact_request_id, onSuccess, onError)
{
    Preconditions.checkNotNull(contact_request_id);
    
    this.makeApiCall({
        'url' : 'contact-requests/'+contact_request_id,
        'method' : 'spam',
        'data' : null,
        'on_response' : 'onResponseGetContactRequest',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.onResponseGetContactRequest = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success(response.response_data);
    }
    else if ( params.on_error != null )
    {
        params.on_error(response.response_data);
    }

    this.handleResponseBackstop(response);
}

RedChirp.prototype.deleteOrganizationAccount = function(organization_account_id, onSuccess)
{
    Preconditions.checkNotNull(organization_account_id);
    
    this.makeApiCall({
        'url' : 'admin/organizations/delete/' + organization_account_id,
        'method' : 'delete',
        'on_response' : 'onResponseDeleteOrganizationAccount',
        'on_response_params' : { 'on_success' : onSuccess },
    });
}

RedChirp.prototype.onResponseDeleteOrganizationAccount = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success();
    }

    this.handleResponseBackstop(response);
}

RedChirp.prototype.onPutArchiveOrganizationInfo = function(data, onSuccess, onError)
{
    Preconditions.checkNotNull(data);

    this.makeApiCall({
        'url' : 'organizations/archive-organization/put/',
        'method' : 'put',
        'data' : data,
        'on_response' : 'onPutArchiveOrganizationInfoResponse',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.onPutArchiveOrganizationInfoResponse = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success(response.response_data);
    }

    this.handleResponseBackstop(response);
}

RedChirp.prototype.onResponsePatchEmployeeAccount = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success();
    }
    else
    {
        if ( params.on_error != null )
        {
            params.on_error(response.message);
            return;
        }
        
    }

    this.handleResponseBackstop(response);
}

RedChirp.prototype.patchOrganizationEndpoint = function(endpoint, changes, onSuccess)
{
    Preconditions.checkString(endpoint);
    Preconditions.checkNotNull(changes);
    
    this.makeApiCall({
        'url' : 'organizations/endpoint/'+endpoint,
        'method' : 'patch',
        'data' : changes,
        'on_response' : 'onResponsePatchOrganizationEndpoint',
        'on_response_params' : { 'on_success' : onSuccess },
    });
}

RedChirp.prototype.onResponsePatchOrganizationEndpoint = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success();
    }

    this.handleResponseBackstop(response);
}

RedChirp.prototype.searchAvailablePhoneNumbers = function(search_code, onSuccess)
{
    if ( search_code == null ) search_code = '';
    Preconditions.checkString(search_code);
    
    this.makeApiCall({
        'url' : 'comms/search-available-phone-numbers?search_code='+search_code,
        'method' : 'list',
        'data' : null,
        'on_response' : 'onResponseSearchAvailablePhoneNumbers',
        'on_response_params' : { 'on_success' : onSuccess },
    });
}

RedChirp.prototype.onResponseSearchAvailablePhoneNumbers = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success(response.response_data.available_numbers);
    }

    this.handleResponseBackstop(response);
}

RedChirp.prototype.orderPhoneNumber = function(params, onSuccess, onError)
{
    Preconditions.checkObject(params);
    
    this.makeApiCall({
        'url' : 'comms/order-phone-number',
        'method' : 'post',
        'data' : params,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.testEcho = function(data, onSuccess, onError)
{
    
    this.makeApiCall({
        'url' : 'test/echo',
        'method' : 'post',
        'data' : data,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.upsertAdfSettings = function(adf_settings, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'integrations/adf/settings',
        'method' : 'post',
        'data' : adf_settings,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.deleteAdfIntegration = function(integration_id, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'integrations/adf/settings/'+integration_id,
        'method' : 'delete',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.getAdfStartData = function(params, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'integrations/adf',
        'method' : 'start',
        'data' : params,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.sendAdfLead = function(params, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'integrations/adf/send',
        'method' : 'send',
        'data' : params,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.recordAdfAddNote = function(params, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'integrations/adf/record',
        'method' : 'post',
        'data' : params,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}


RedChirp.prototype.deleteDomain = function(domain_obj, onSuccess, onError)
{
    Preconditions.checkObject(domain_obj);
    
    this.makeApiCall({
        'url' : 'organizations/domains/'+domain_obj.organization_id+'/'+domain_obj.domain,
        'method' : 'delete',
        'data' : null,
        'on_response' : 'onResponseDeleteDomain',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.onResponseDeleteDomain = function(response, params)
{
    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success();
        
        return;
    }

    if ( params.on_error != null )
        params.on_error();
}

RedChirp.prototype.listInboxEmail = function(search, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'inbox-email',
        'method' : 'list',
        'data' : search,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.postEmployeeGroup = function(group, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'organizations/employee-groups',
        'method' : 'post',
        'data' : group,
        'on_response' : 'onResponsePostEmployeeGroup',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}



RedChirp.prototype.deleteEmployeeGroup = function(organization_id, group_id, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'organizations/employee-groups/'+organization_id+'/'+group_id,
        'method' : 'delete',
        'data' : null,
        'on_response' : 'onResponsePostEmployeeGroup',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.moveEmployeeGroup = function(organization_id, group_id, direction, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'organizations/employee-groups/'+organization_id+'/'+group_id+'/move/'+direction,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponsePostEmployeeGroup',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.onResponsePostEmployeeGroup = function(response, params)
{
    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success();
        
        return;
    }

    if ( params.on_error != null )
        params.on_error();
}

RedChirp.prototype.postInboxURLs = function(organization_id, inbox_urls, onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'organizations/inbox-urls/'+organization_id,
        'method' : 'post',
        'data' : { 'inbox_urls' : inbox_urls },
        'on_response' : 'onResponseGetOrganizationProfile',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}



RedChirp.prototype.onResponseVerifyDomain = function(response, params)
{
    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success();
        
        return;
    }

    if ( params.on_error != null )
        params.on_error();
}


RedChirp.prototype.createEmployee = function(new_employee_data, onSuccess, onError)
{
    Preconditions.checkNotNull(new_employee_data);
    
    this.makeApiCall({
        'url' : 'organizations/create-new-employee',
        'method' : 'post',
        'data' : new_employee_data,
        'on_response' : 'onResponseCreateEmployee',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.onResponseCreateEmployee = function(response, params)
{
    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success();
        
        return;
    }

    if ( params.on_error != null )
        params.on_error(response.message);
}

RedChirp.prototype.setPassword = function(password_data, onSuccess, onError)
{
    Preconditions.checkNotNull(password_data);
    
    this.makeApiCall({
        'url' : 'auth/set-password',
        'method' : 'post',
        'data' : password_data,
        'on_response' : 'onResponseSetPassword',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.onResponseSetPassword = function(response, params)
{
    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success();
        
        return;
    }

    if ( params.on_error != null )
        params.on_error(response.message);
}

RedChirp.prototype.listAvailableAlertSounds = function(onSuccess, onError)
{
    this.makeApiCall({
        'url' : 'sounds/alert/'+this.$state.employee_id,
        'method' : 'list',
        'data' : null,
        'on_response' : 'onResponseListAvailableAlertSounds',
        'on_response_params' : { 'on_success' : onSuccess, 'on_error' : onError },
    });
}

RedChirp.prototype.testSignalCallStartRinging = function(signal, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'test/send-signal-call-start-ringing',
        'method' : 'post',
        'data' : signal,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.testSignalCallStopRinging = function(signal, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'test/send-signal-call-stop-ringing',
        'method' : 'post',
        'data' : signal,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.getContactRequestValidation = function(contact_request_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'contact-requests/'+contact_request_id,
        'method' : 'get-validation',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}


RedChirp.prototype.adminVerifyAllOrgNumbers = function(organization_id, on_success, on_error)
{
    this.makeApiCall({
        'url' : 'admin/verify-all-org-numbers/'+organization_id,
        'method' : 'get',
        'data' : null,
        'on_response' : 'onResponseStandard',
        'on_response_params' : { 'on_success' : on_success, 'on_error' : on_error },
    });
}

RedChirp.prototype.onResponseListAvailableAlertSounds = function(response, params)
{
    if ( this.handleUnauthrozied(response) ) return;

    if ( response.http_status_code === 200 )
    {
        if ( params.on_success != null )
            params.on_success(response.response_data.alert_sounds);
    }
    else if ( params.on_error != null )
    {
        params.on_error();
        return;
    }

    this.handleResponseBackstop(response);
}

RedChirp.prototype.handleUnauthrozied = function(response)
{
    if ( response.http_status_code !== 401 ) return false;
    if ( response.path == '/api/v1/auth/sign-in' ) return false; // does not handle unauthrozied responses to the sign in end point (that should be passed through so the front end can properly handle)

    // Don't redirect during authentication completion to avoid race conditions
    if ( this._sso_completion_in_progress || this._auth_completion_in_progress ) return true;

    // Don't log out while checking if a demo setup is running (unauthorized happens all the time here because all employees are deleted...)
    if ( response != null && response.path != null && response.path.startsWith('/api/v1/admin/demo/is-demo-setup-running') ) return true;

    // In dev, auto sign out (typically because of resetting test data)
    if ( this.inDev() && this.$state.offerSignOutReturnToAdminAccount() )
    {
        this.completeSignInAs(
            this.$state.getAuthActorEmployeeId(),
        
            (data) => {
            },
        
            () => {
                window.location = '/app/sign-in';
            },
        );

        return;
    }

    window.localStorage.setItem('rc_after_sign_in_url', window.location);

    window.location = '/app/sign-in';
    return true;
}

RedChirp.prototype.handleResponseBackstop = function(response)
{
    // Ignore any "ok" responses that get here (just throw them away)
    if ( response.http_status_code >= 200 && response.http_status_code < 300 ) 
        return false;

    this.$emit('backstop-error-handler', response);
}

RedChirp.prototype.testBackstopErrorHandler = function(response)
{
    this.$emit('backstop-error-handler', response);
}

RedChirp.prototype.handleSilentOk = function(response)
{
    if ( response.http_status_code >= 200 && response.http_status_code < 300 )
        return true;

    return false;
} 

RedChirp.prototype.handleSilentNotFound = function(response)
{
    if ( response.http_status_code == 404 )
        return true;

    return false;
} 



RedChirp.prototype.makeApiCall = async function(params)
{
    if ( Preconditions.isNull(params.method) ) params.method = 'get';

    let axios_data = null;

    let axios_headers = {
        'visitor_id': this.getFingerprintVisitorId(),
    };
   

    if ( !Preconditions.isNull(params.form_data) )
    {
        axios_data = params.form_data;
        axios_headers['Content-Type'] = 'multipart/form-data';
    }
    else if ( !Preconditions.isNull(params.data) )
    {
        axios_data = JSON.stringify(params.data);
        axios_headers['Content-type'] = 'application/json; charset=UTF-8';
    }

    if ( Preconditions.isNull(params.on_response) )
        params.on_response = 'silentOk';

    if ( Preconditions.isNull(params.on_response) )
        params.on_response = 'silentOk';

    if ( Preconditions.isNull(params.on_response_params) )
        params.on_response_params = {};

    Preconditions.checkString(params.url);
    Preconditions.checkString(params.method);
    Preconditions.checkString(params.on_response);

    let path = params.url;

    if ( params.axios_fail_silent == true )
        this.alert('hola!');


    let axios_request = {
            'url' : this.getAPIEndpoint(params.url, params.force_ngrok_in_dev),
            'method' : params.method,
            'data' : axios_data,
            'headers' : axios_headers,
            'timeout' : params.timeout == null ? 30000 : params.timeout, 
            'onUploadProgress' : params.on_upload_progress,
            'raxConfig' : raxConfig
        };

    var this_object = this;

    let responseFunc = (response) =>
    {
        let request_start_time = this.getDeep(response, 'request_data/request_start_time');
        let request_path = this.getDeep(response, 'request_data/path/absolute_path');
        
        if ( request_start_time != null && request_path != null && this.request_time_map != null )
        {
            let cur_latest_time = this.request_time_map.get(request_path);

            if ( cur_latest_time != null && request_start_time < cur_latest_time ) 
            {
                return; // Prevents an old (long running) request on this path from (after a newer request) returning data...
            }

            this.request_time_map.set(request_path, request_start_time);
        }

        if ( response.http_status_code !== 200 )
        {
            this_object.logFailedRequest(axios_request, response);
        }

        try
        {
            this_object[params.on_response](response, params.on_response_params);
        }
        catch(front_end_error)
        {
            let i = 0;
        }
    }

    axios.defaults.headers.common['Authorization'] = this.$state.getAuthToken();
    axios.defaults.headers.common['act_as'] = this.$state.getAuthActAs();
    axios.defaults.headers.common['red-chirp-device-id'] = this.$state.getDeviceId();

    axios.request(axios_request)
     .then( ({ data }) => {
        
        let response = data;
        response.path = path;

        responseFunc(response);
 
         return true;
     })
     .catch((err) => 
         {
             if ( Preconditions.isNull(err.response) )
             {
                responseFunc({
                    'path' : path,
                    'http_status_code' : 503, // service unavaiable
                    'response_type_code' : 'error',
                    'message' : 'the server did not reply',
                    'request_data' : {},
                    'response_data' : {}
                });
                return true;
             }

             if ( Preconditions.isNull(err.response.data) || err.response.data === "" )
             {
                responseFunc({
                    'path' : path,
                    'http_status_code' : err.response.status,
                    'response_type_code' : 'error',
                    'message' : 'the request returned a '+err.response.status+' error',
                    'request_data' : {},
                    'response_data' : {}
                });
                return true;
             }
            
            let response = err.response.data;
            response.path = path;

            responseFunc(err.response.data);
            
            return true;
         }
     );
}

RedChirp.prototype.logFailedRequest = function(request, response)
{
    let data = {
        'message' : 'failed_front_end_request',
        'front_end_host_name': (''+location.hostname).toLowerCase(),
        'front_end_location' : ''+location,
        'organization_id' : this.safeGet(this.$state, ['profile','organization_account','organization_id']),
        'organization_label' : this.safeGet(this.$state, ['profile','organization_account','label']),
        'employee_id' : this.safeGet(this.$state, ['profile','employee_account','employee_id']),
        'username' : this.safeGet(this.$state, ['profile','employee_account','username']),
        'request' : request,
        'response' : response
    };

    let log_request = {
        'url' : 'https://staging-redchirp.com/api/v1/public/log-front-end',
        'method' : 'post',
        'data' : data,
        'timeout' : 15000,
    };

    axios.request(log_request)
     .then( ({ data }) => {})
     .catch((err) => {});
}

/*
RedChirp.prototype.testServerUp = function(call_back)
{
    let log_request = {
        'url' : this.getAPIEndpoint('test/echo', false),
        'method' : 'post',
        'data' : { 'echo_str': 'foo' },
        'timeout' : 15000,
    };


    axios.request(log_request)
     .then( ({ data }) => {call_back(true);})
     .catch((err) => {call_back(false);});
}*/

RedChirp.prototype.safeGet = function(obj, path)
{
    for ( let i = 0; i < path.length; i++ )
    {
        if (obj == null) 
            return null;

        obj = obj[path[i]];
    }

    return obj;
}

RedChirp.prototype.getApiErrorMessage = function(response, default_message)
{
    if ( response == null )
    {
        return default_message || 'An unexpected error occurred';
    }

    var message = this.safeGet(response, ['response_data','message']);

    if ( (message == null || message.length === 0) && response.message )
    {
        message = response.message;
    }

    if ( (message == null || message.length === 0) && response.error )
    {
        message = response.error;
    }

    if ( message != null && message.length > 0 )
    {
        return message;
    }

    return default_message || 'An unexpected error occurred';
}

RedChirp.prototype.simplePickEmoji = function(after_pick_function)
{
    let params = {
        'after_pick_function': after_pick_function,
    };

    this.$event_bus.$emit('pick-emoji', params);
}

RedChirp.prototype.showSpinner = function(text)
{
    this.$event_bus.$emit('show-spinner', text);
}

RedChirp.prototype.hideSpinner = function()
{
    this.$event_bus.$emit('hide-spinner');
}

RedChirp.prototype.next_page_snackbar = function(text, timeout)
{
    let params = {
        'text' : text,
        'timeout' : timeout,
    };

    localStorage.setItem('next_page_snackbar', JSON.stringify(params));
}

RedChirp.prototype.clear_next_page_snackbar = function()
{
    let string_params = localStorage.getItem('next_page_snackbar');
    if ( string_params == null ) return null;

    localStorage.removeItem('next_page_snackbar');
    return JSON.parse(string_params);
}

RedChirp.prototype.snackbar = function(text, timeout)
{
    if ( timeout == null ) timeout = 3000;

    this.$event_bus.$emit('snackbar',{
        'text' : text,
        'timeout' : timeout,
    });
}

RedChirp.prototype.closeSnackbar = function(text, timeout)
{
    if ( timeout == null ) timeout = 3000;

    this.$event_bus.$emit('close-snackbar');
}

RedChirp.prototype.alert = function(title, text, after_alert, check_front_end_version = false)
{
    if ( typeof title === 'object' )
    {
        // Rich alert...
        let params = title;

        if ( params.after_alert == null )
        {
            params.after_alert = () => {}
        }

        this.$event_bus.$emit('alert', params);
    }
    else
    {
        if ( after_alert == null ) 
            after_alert = () => {};

        this.$event_bus.$emit('alert', {
            'title' : title,
            'text' : text,
            'after_alert': after_alert,
            'check_front_end_version': check_front_end_version,
        });
    }
}

RedChirp.prototype.alertMarkdown = function(title, text_md, after_alert)
{
    if ( after_alert == null ) 
        after_alert = () => {};

    this.$event_bus.$emit('alert', {
        'title' : title,
        'text' : text_md,
        'after_alert': after_alert,
        'text_markdown': true,
    });
}

RedChirp.prototype.confirm = function(title, text, actions, after_confirm)
{
    let text_to_confirm_message = null;
    let text_to_confirm = null;

    if ( text == null && actions == null && after_confirm == null )
    {
        // Updated version of the function that takes an object
        let params = title;

        if ( params.title == null ) params.title = 'Confirm';
        if ( params.body == null ) params.body = 'Technical error: You need to set the body parameter';
        if ( params.btn_text_cancel == null ) params.btn_text_cancel = 'Cancel';
        if ( params.btn_text_ok == null ) params.btn_text_cancel = 'Confirm';

        title = params.title;
        text = params.body;

        actions = [
            {'text': params.btn_text_cancel, 'value': 'cancel' },
            {'text': params.btn_text_ok, 'value': 'ok' },
        ];

        after_confirm = (response) => {

            if (response == 'ok' && params.on_ok != null )
            {
                params.on_ok();
            } 

            if (response == 'cancel' && params.on_cancel != null )
            {
                params.on_cancel();
            } 
        };

        text_to_confirm_message = params.text_to_confirm_message;
        text_to_confirm = params.text_to_confirm;
    }

    if ( after_confirm == null ) 
        after_confirm = () => {};

    this.$event_bus.$emit('confirm', {
        'title' : title,
        'text' : text,
        'actions' : actions,
        'after_confirm': after_confirm,
        'text_to_confirm': text_to_confirm,
        'text_to_confirm_message': text_to_confirm_message,
    });
}

RedChirp.prototype.warn = function(params)
{
    this.$event_bus.$emit('warn', params);
}

RedChirp.prototype.technicalDetails = function(params)
{
    this.$event_bus.$emit('technical_details', params);
}

RedChirp.prototype.startProcess = function(params)
{
    this.rest({
        'spinner': false,
        'endpoint': 'PUT: /api/v1/process/start',
    
        'params' : {
            'type': params.type,
            ... (params.params ?? {})
        },
    
        'on_success': (data) => {
                params.process_id = data.process_id;
                this.$event_bus.$emit('global-process-dialog', params);
            },
    
        'on_error': 'Unable to start process',
    });
}

RedChirp.prototype.confirmWithResponse = function(title, text, required_response, actions, after_confirm)
{
    if ( after_confirm == null )
        after_confirm = () => {};

    this.$event_bus.$emit('confirm-with-response', {
        'title' : title,
        'text' : text,
        'required_response' : required_response,
        'actions' : actions,
        'after_confirm': after_confirm,
    });
}

RedChirp.prototype.requestNumber = function(title, text, actions, after_confirm)
{
    if ( after_confirm == null )
        after_confirm = () => {};

    this.$event_bus.$emit('request-number', {
        'title' : title,
        'text' : text,
        'actions' : actions,
        'after_confirm': after_confirm,
    });
}

RedChirp.prototype.newSignInAs = function(params)
{
     this.$event_bus.$emit('sign-in-as', params);
}

RedChirp.prototype.newSignInAsAuthAccount = function(params)
{
    params.organization_id = this.$state.getAuthActor().organization_id;
    params.employee_id = this.$state.getAuthActor().employee_id;


    this.$event_bus.$emit('sign-in-as', params);
}



RedChirp.prototype.promptTime = function(params)
{
    this.$event_bus.$emit('pick_time_dialog', params);
}

RedChirp.prototype.prompt = function(params)
{
    // Setup default actions.. (OK and Cancel...)
    if ( params.actions == null )
    {
        params.actions = [
            {'text' : 'Cancel', 'value' : null },
            {'text' : 'Ok', 'value' : 'ok' },
        ];
    }

    this.$event_bus.$emit('prompt', params);
}

RedChirp.prototype.excelExport = function(endpoint, params)
{
    this.rest(
        endpoint,
        params,
    
        (data) => {
            this.$event_bus.$emit('excel_export_dialog', data);
        },
    
        () => {
            this.$rc.alert('Error','Unable to export');
        },
    );
}

RedChirp.prototype.copy_code_dialog = function(params)
{
    this.$event_bus.$emit('copy_code_dialog', params);
}

RedChirp.prototype.copy_dialog = function(params)
{
    this.$event_bus.$emit('copy_dialog', params);
}

RedChirp.prototype.contactSupport = function(params)
{
    if ( typeof params === 'string' )
    {
        params = {
            'page_name': params,
        };
    }
    this.$event_bus.$emit('support_dialog', params);
}

RedChirp.prototype.change_tags_dialog = function(params)
{
    this.$event_bus.$emit('change_tags_dialog', params);
}

RedChirp.prototype.pick = function(params)
{
    this.$event_bus.$emit('pick_dialog', params);
}

RedChirp.prototype.combo_box_prompt = function(params)
{
    // Setup default actions.. (OK and Cancel...)
    if ( params.actions == null )
    {
        params.actions = [
            {'text' : 'Cancel', 'value' : null },
            {'text' : 'Ok', 'value' : 'ok' },
        ];
    }

    this.$event_bus.$emit('combo_box_prompt', params);
}

RedChirp.prototype.promptSelect = function(params)
{
    // Setup default actions.. (OK and Cancel...)
    if ( params.actions == null )
    {
        params.actions = [
            {'text' : 'Cancel', 'value' : null },
            {'text' : 'Ok', 'value' : 'ok' },
        ];
    }

    this.$event_bus.$emit('select_prompt', params);
}

RedChirp.prototype.getAPIEndpoint = function(path, force_ngrok_in_dev)
{
    Preconditions.checkString(path);

    if ( path.startsWith('/api/v1/') )
        path = path.substring('/api/v1/'.length);

    let hostname = (''+location.hostname).toLowerCase();
    if ( hostname == null ) return null;

    if ( hostname === 'app.redchirp.com' ) return 'https://app.redchirp.com/api/v1/'+path;
    if ( hostname === 'redchirp.com' ) return 'https://redchirp.com/api/v1/'+path;

    if ( hostname === 'www.staging-redchirp.com' ) return 'https://www.staging-redchirp.com/api/v1/'+path;
    if ( hostname === 'staging-redchirp.com' ) return 'https://staging-redchirp.com/api/v1/'+path;

    if ( hostname.endsWith('-front-end-redchirp.ngrok.io') ) return 'https://'+hostname.replace('-front-end-redchirp.ngrok.io','-rest-redchirp.ngrok.io')+'/api/v1/'+path;

    if ( force_ngrok_in_dev )
    {
        return 'http://kanej-rest-redchirp.ngrok.io/api/v1/'+path;
    }

    return 'http://127.0.0.1:8080/api/v1/'+path;
}

RedChirp.prototype.loadCustomFonts = function(organization_id)
{
    this.rest({
        'spinner': false,
        'endpoint': 'LIST: /api/v1/css/available-font-families',
    
        'params' : {
                'organization_id': organization_id,
            },
    
        'on_success': (data) => {
                data.custom_fonts.forEach(
                    (font) => {
                        const myFont = new FontFace(
                            font.font_family_name, 
                            'url('+font.url+')' // Font file URL
                        );

                        document.fonts.add(myFont);
                    }
                );
            },
    
        'on_error': 'Unable to load custom fonts',
    });
}



RedChirp.prototype.qrCodeURL = function(qr_code_id, width, height)
{
    return this.getAPIEndpoint('/api/v1/qr-code/'+qr_code_id+'/'+width+'/'+height+'/qr-code.png',false);
}

RedChirp.prototype.getSignedInOnlyBlobUrl = function(object_name)
{
    return this.getAPIEndpoint("signed-in-only-blobs/"+object_name, false);
}

RedChirp.prototype.getEnvironment = function()
{
    let url = (''+this.getAPIEndpoint("/api/v1/public/get-environment", false)).toLowerCase();

    if ( url.includes('127.0.0.1') || url.includes('ngrok.io') ) return 'dev';
    if ( url.includes('staging-redchirp') ) return 'staging';
    
    return 'production';
}

RedChirp.prototype.isAuthActorProhibitedFromUsingFrontEnd = function()
{
    if ( this.$state == null || this.$state.profile == null ) 
        return false;
        
    if ( !this.$state.isAuthActorSystemAdmin() )
        return false;

    if ( this.getEnvironment() != 'production' )
       return false;

    let auth_username = this.getDeep(this.$state.profile,'auth_employee_account/username');

    if ( auth_username == null ) return true;
    if ( !auth_username.toLowerCase().endsWith("@redchirp.com") ) return true;

    return false;
}

RedChirp.prototype.inDev = function()
{
    return this.getEnvironment() == 'dev';
}

RedChirp.prototype.inStaging = function()
{
    return this.getEnvironment() == 'staging';
}

RedChirp.prototype.inProduction = function()
{
    return this.getEnvironment() == 'production';
}

RedChirp.prototype.isSystemAdmin = function()
{
    return this.$state.isSystemAdmin();
}

RedChirp.prototype.isAuthActorSystemAdmin = function()
{
    return this.$state.isAuthActorSystemAdmin();
}

RedChirp.prototype.inIndustry = function(industry_code)
{
    if ( this.isEnumAny(industry_code) ) return true;

    if ( this.$state.profile == null ) return false;
    if ( this.$state.profile.organization_account == null ) return false;

    return this.$state.profile.organization_account.industry == industry_code;
}

RedChirp.prototype.getOrganizationId = function()
{
    return this.$state.getOrganizationId();
}


RedChirp.prototype.isFeatureEnabledSetInboundCallerIdMode = function()
{
    let org_id = this.getOrganizationId();

    return org_id == this.ORG_ID_RED_ROCK_REALTY || org_id == this.ORG_ID_CLASS_VI_PARTNERS;
}

RedChirp.prototype.isFeatureEnabledMessagePrivacyMode = function()
{
    let org_id = this.getOrganizationId();

    return org_id == this.ORG_ID_RED_ROCK_REALTY || org_id == this.ORG_ID_CLASS_VI_PARTNERS;
}


RedChirp.prototype.toHomeForEndpoint = function($router, endpoint, open_in_new_window, conversation_id)
{
    open_in_new_window = open_in_new_window === true;

    this.showSpinner();
    

    this.rest(
        'GET: /api/v1/conversations/message-privacy/before-switching-to-endpoint/:endpoint',
            
        {
            'endpoint' : endpoint,
        },
            
        (data) => 
        {
            this.hideSpinner();

            if ( !data.can_switch )
            {
                this.alert("Not authorized", "You do not have permission to view conversations on this phone number");
                return;
            }

            if ( !data.warn_before_switch )
            {
                this.afterPermissionsCheckGoHomeForEndpoint($router,endpoint,open_in_new_window, conversation_id);
                return;
            }

            // Warn the user before switching
            // Used to warn, Angela did'nt like it so it has been removed

            this.afterPermissionsCheckGoHomeForEndpoint($router,endpoint,open_in_new_window, conversation_id);
            
            /*this.confirm(
                'Phone number not assigned to you',
                'Your organization policy is for users to only see conversations on phone numbers assigned to them.<br/><br/>Because you are an organization administrator, you may view the conversations on this number despite it not being assigned to you.<br/><br/>Would you like to proceed?',
                [
                    {'text': 'Cancel', 'value': 'cancel'},
                    {'text': 'Continue', 'value': 'confirm'},
                ],
            
                (response) => {
                    if (response != 'confirm') return;
                    
                    this.afterPermissionsCheckGoHomeForEndpoint($router,endpoint,open_in_new_window, conversation_id);
                }
            );*/
        },

        () =>
        {
            this.hideSpinner();
            this.alert('Unable to view conversations');
        }
    );
}

RedChirp.prototype.afterPermissionsCheckGoHomeForEndpoint = function($router, endpoint, open_in_new_window, conversation_id)
{
    open_in_new_window = open_in_new_window === true;

    let route = null;

    if ( conversation_id != null )
    {
        route = {
            'name': 'home-routed',
            'params' : {
                'endpoint' : E164.slimEndpoint(endpoint),
                'conversation_id' : conversation_id,
            }
        };
    }
    else
    {
        route = { 
            name: 'home_with_endpoint', 
            params: { 
                'endpoint': E164.slimEndpoint(endpoint),
                'conversation_id': 'none'
            } 
        };
    }


    if ( open_in_new_window )
    {
        let routeData = $router.resolve(route);
        window.open(routeData.href, '_blank');

        return;
    }

    $router.push(route);
}

RedChirp.prototype.updateFingerprint = function()
{
    if ( localStorage.getItem("rc_device_fingerprint") != null )
    {
        let rc_device_fingerprint_creation_time = this.getFingerprint().rc_device_fingerprint_creation_time;
        let cutoff_time = (new Date()).getTime() - 86400000 / 24; // one hour

        if ( rc_device_fingerprint_creation_time != null && rc_device_fingerprint_creation_time > cutoff_time )
            return;
    }

    try
    {
        let fpPromise = FingerprintJS.load({
            apiKey: 'Ws8Iwcwai9l5mOMUr2Bc', // was previously 'token' - https://dev.fingerprint.com/changelog/3-5-6
            endpoint: 'https://fp.redchirp.com',
            scriptUrlPattern: [
                'https://fp.redchirp.com/web/v<version>/<apiKey>/loader_v<loaderVersion>.js',
                FingerprintJS.defaultScriptUrlPattern, // fallback
            ],
        });
        
        // Get the visitor identifier when you need it.
        fpPromise
            .then(fp => fp.get({extendedResult: true}))
            .then(result => {
                result.rc_device_fingerprint_creation_time = (new Date()).getTime();
                localStorage.setItem("rc_device_fingerprint", JSON.stringify(result));
                this.$emit('rc_device_fingerprint');

                this.rest({
                    'spinner': false,
                    'endpoint': 'PUT: /api/v1/device-info',
                    'params' : result,
                    'on_success': (data) => {},
                    'on_error': () => {},
                });
            });
    }
    catch(error)
    {
        let i = 0; // because the darn block can not be empty or there is a lint error
    }
}

RedChirp.prototype.getFingerprint = function()
{
    let fp_str = localStorage.getItem("rc_device_fingerprint");

    if ( fp_str == null )
    {
        return this.getUnknownFigerprint();
    }

    try {
        return JSON.parse(fp_str);
    }
    catch(error)
    {
        localStorage.removeItem("rc_device_fingerprint");
        return this.getUnknownFigerprint();
    }
}

RedChirp.prototype.getUnknownFigerprint = function()
{
    return {
        'unknown_device_fingerprint' : true,
        'incognito' : false,
        'browserName' : 'Unknown',
        'device' : 'Unknown',
    };
}

RedChirp.prototype.inPrivateBrowsingMode = function()
{
    return this.getFingerprint().incognito == true;
}

RedChirp.prototype.getFingerprintVisitorId = function(default_value)
{
    let ret = this.getFingerprint();
    
    if ( ret == null ) return default_value;
    if ( ret.visitorId == null ) return default_value;

    return ret.visitorId;
}



RedChirp.prototype.isBrowser = function(name)
{
    name = name.toLowerCase();

    let fp = this.getFingerprint();
    if ( fp == null ) return false;

    let browser_name = ''+fp.browserName;
    if ( browser_name == null ) browser_name = 'Unknown';
    browser_name = browser_name.toLowerCase();

    return browser_name.includes(name);
}

RedChirp.prototype.isDevice = function(name)
{
    name = name.toLowerCase();

    let fp = this.getFingerprint();
    if ( fp == null ) return false;

    let device_name = ''+fp.device;
    if ( device_name == null ) name = 'Unknown';
    device_name = device_name.toLowerCase();

    return device_name.includes(name);
}

RedChirp.prototype.isIPhone = function()
{
    return this.isDevice('iPhone');
}

RedChirp.prototype.isIPad = function()
{
    return this.isDevice('iPad');
}


RedChirp.prototype.getNameOfPrivateBrowsingMode = function()
{
    if ( this.isBrowser('Chrome') )
        return 'Incoginto';
    
    return 'Private Browsing';
}

RedChirp.prototype.offerAddToHomeScreen = function()
{
    if ( this.isSystemAdmin() )
        return true;

    if ( !this.isIPhone() && !this.isIPad() )
        return false;

    return this.isBrowser('Safari');
}

RedChirp.prototype.htmlLinebreak = function(str)
{
    if ( str == null ) return '';

    str = str.replaceAll("\r","");
   
    return str.replaceAll("\n","<br/>");
}

RedChirp.prototype.getDeep = function(start, path)
{
    return this.$state.getDeep(start,path);
}

const gsm_code_points = new Set([
    0x000a, 0x000c, 0x000d, 
    0x0020, 0x0021, 0x0022, 0x0023, 0x0024, 0x0025, 0x0026, 0x0027, 0x0028, 0x0029, 0x002a, 0x002b, 0x002c, 0x002d, 0x002e, 0x002f,
    0x0030, 0x0031, 0x0032, 0x0033, 0x0034, 0x0035, 0x0036, 0x0037, 0x0038, 0x0039, 0x003a, 0x003b, 0x003c, 0x003d, 0x003e, 0x003f,
    0x0040, 0x0041, 0x0042, 0x0043, 0x0044, 0x0045, 0x0046, 0x0047, 0x0048, 0x0049, 0x004a, 0x004b, 0x004c, 0x004d,
    0x004e, 0x004f,
    0x0050, 0x0051, 0x0052, 0x0053, 0x0054, 0x0055, 0x0056, 0x0057, 0x0058, 0x0059,  0x005a, 0x005b, 0x005c, 0x005d, 0x005e, 0x005f, 
    0x0061, 0x0062, 0x0063, 0x0064, 0x0065, 0x0066, 0x0067, 0x0068, 0x0069, 0x006a, 0x006b, 0x006c, 0x006d, 0x006e, 0x006f, 
    0x0070, 0x0071, 0x0072, 0x0073, 0x0074, 0x0075, 0x0076, 0x0077, 0x0078, 0x0079, 0x007a, 0x007b, 0x007c, 0x007d, 0x007e,
    0x00a1, 0x00a3, 0x00a4, 0x00a5, 0x00a7,
    0x00bf,
    0x00c4, 0x00c5, 0x00c6, 0x00c7, 0x00c9,
    0x00d1, 0x00d6, 0x00d8, 0x00dc, 0x00df,
    0x00e0, 0x00e4, 0x00e5, 0x00e6, 0x00e8, 0x00e9, 0x00ec,
    0x00f1, 0x00f2, 0x00f6, 0x00f8, 0x00f9, 0x00fc,
    0x0393, 0x0394, 0x0398, 0x039b, 0x039e, 0x03a0, 0x03a3, 0x03a6, 0x03a8, 0x03a9,
    0x20ac,
]);
  
const gsm_two_chars = new Set([
    0x000c, 0x005e, 0x007b, 0x007d, 0x005c, 0x005b, 0x007e, 0x005d, 0x007c,
]);

  RedChirp.prototype.messageType = function(text, always_mms)
  {
    if ( text == null ) return null;

    text = text.trim();

    if ( text.length == 0 )
        return null;

    if ( always_mms || text.length > 160 )
        return 'MMS ('+this.codePointLength(text)+'/1600)';

    let non_gsm_chars = false;
    let gsm_char_count = 0;
    
    for (const s of text) 
    {
        let codePoint = s.codePointAt(0);
        if ( codePoint == null ) continue;

        if ( !gsm_code_points.has(codePoint) ) 
        {
            non_gsm_chars = true;
            break;
        }

        if ( gsm_two_chars.has(codePoint) )
        {
            gsm_char_count += 2;
        }
        else
        {
            gsm_char_count++;
        }
    }

    if ( non_gsm_chars )
    {
        if ( text.length > 70 )
            return 'MMS ('+this.codePointLength(text)+'/1600)';
        
        return 'SMS ('+text.length+'/70)'; 
    }

    if ( gsm_char_count <= 160 )
    {
        return 'SMS ('+gsm_char_count+'/160)'; 
    }

    return 'MMS ('+this.codePointLength(text)+'/1600)';
}

RedChirp.prototype.codePointLength = function(text)
{
    let count = 0;

    // for..of iterates over Unicode code points
    // String.length counts UTF-16 code units (so not the same)
    for (const cp of text)
        count++;

    return count;
}

RedChirp.prototype.wrapHTML = function(html_as_text, count_hits)
{
    let ret = html_as_text;

    ret = this.escapeHTML(ret);
    ret = this.wrapHyperlinks(ret, count_hits);
    ret = this.wrapBold(ret);
    

    ret = ret.replaceAll('\n','<br/>');

    return ret;
}

RedChirp.prototype.wrapBold = function(src)
{
    let ret = '';

    let at = () => {

        let tmp = src;

        if ( !tmp.startsWith('**') )
            return null;

        tmp = tmp.substring(2);

        let idx = tmp.indexOf('**');

        if ( idx == -1 ) 
            return null;

        let contents = tmp.substring(0,idx);

        if ( contents.includes('<a>') || contents.includes('://') || contents.length == 0 )
            return null;

        src = tmp.substring(idx+2);

        return '<b>'+contents+'</b>';
    }    

    while( src.length > 0 )
    {
        let wrap = at();
        if ( wrap != null )
        {
            ret += wrap;
            continue;
        }

        ret += src.charAt(0);
        src = src.substring(1);
    }

    return ret;
}

RedChirp.prototype.getOpenPanel = function(route)
{
    let open_panel = parseInt(route.query.open_panel);

    if ( isNaN(open_panel) )
        return null;

    return open_panel;

}

RedChirp.prototype.permuteRoute = function(cur_route, changes)
{
    if ( changes == null ) 
        return cur_route;

    let params = cur_route.params;
    if ( params == null ) params = {};

    let query = cur_route.query;
    if ( query == null ) query = {};

    let param_changes = changes.params;
    if ( param_changes == null ) param_changes = {};

    let query_changes = changes.query;
    if ( query_changes == null ) query_changes = {};

    return {
        'name': cur_route.name,
        'params': {...params, ...param_changes},
        'query': {...query, ...query_changes},
    };
}

RedChirp.prototype.escapeHTML = function(unsafe)
{
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

RedChirp.prototype.wrapHyperlinks = function(text, count_hits)
{
    if ( text == null ) return '';
    if ( text.length == 0 ) return '';

    if ( count_hits == null ) count_hits = false;

    let result = '';

    while ( text.length > 0 )
    {
        // Handle leading whitespace
        if ( /\s/.test(text.charAt(0)) )
        {
            result += text.charAt(0);
            text = text.substring(1);
            continue;
        }

        // Extract the word
        let word = '';
        while ( text.length > 0 )
        {
            let char = text.charAt(0);

            if ( /\s/.test(char) )
            {
                break;
            }

            word += char;
            text = text.substring(1);
        }

        // Handle ending punctuation
        let ending_punctuation = '';
        if ( word.length > 1 && (word.endsWith('.') || word.endsWith(',') || word.endsWith(';') || word.endsWith('!')) )
        {
            ending_punctuation = word.substring(word.length-1);
            word = word.substring(0, word.length-1);
        }

        // Wrap URLs
        if ( word.toLowerCase().startsWith("http://") || word.toLowerCase().startsWith("https://") )
        {
            word = '<a style="word-break: break-all;" target="_blank" href="'+this.modifyBrandedShortLinksToNotCountHits(word, count_hits)+'">'+word+"</a>";
        }

        // Wrap www links
        if ( word.toLowerCase().startsWith("www.") && word.length > 4 )
        {
            word = '<a style="word-break: break-all;" target="_blank" href="http://'+this.modifyBrandedShortLinksToNotCountHits(word, count_hits)+'">'+word+"</a>";
        }

        result += word + ending_punctuation;
    }

    return result;
}

RedChirp.prototype.modifyBrandedShortLinksToNotCountHits = function(url, count_hits)
{
    if ( count_hits == null ) count_hits = false;
    if ( count_hits ) return url;

    let values = this.enumValues('short_link_domain');

    let is_short_link = false;

    for ( let i = 0; i < values.length; i++ )
    {
        if ( url.toLowerCase().includes(values[i].value) )
        {
            is_short_link = true;
        }
    }

    if ( !is_short_link )
        return url;

    if ( url.includes("?") )
        return url+"&count_hits=false";
    else
        return url+"?count_hits=false";
}

RedChirp.prototype.locationChoices = function()
{
    return [{"text":"Alaska","value":"US-AK"},{"text":"Alabama","value":"US-AL"},{"text":"American Samoa","value":"US-AS"},{"text":"Arizona","value":"US-AZ"},{"text":"Arkansas","value":"US-AR"},{"text":"California","value":"US-CA"},{"text":"Colorado","value":"US-CO"},{"text":"Connecticut","value":"US-CT"},{"text":"Delaware","value":"US-DE"},{"text":"District of Columbia","value":"US-DC"},{"text":"Florida","value":"US-FL"},{"text":"Georgia","value":"US-GA"},{"text":"Guam","value":"US-GU"},{"text":"Hawaii","value":"US-HI"},{"text":"Idaho","value":"US-ID"},{"text":"Illinois","value":"US-IL"},{"text":"Indiana","value":"US-IN"},{"text":"Iowa","value":"US-IA"},{"text":"Kansas","value":"US-KS"},{"text":"Kentucky","value":"US-KY"},{"text":"Louisiana","value":"US-LA"},{"text":"Maine","value":"US-ME"},{"text":"Maryland","value":"US-MD"},{"text":"Massachusetts","value":"US-MA"},{"text":"Michigan","value":"US-MI"},{"text":"Minnesota","value":"US-MN"},{"text":"Mississippi","value":"US-MS"},{"text":"Missouri","value":"US-MO"},{"text":"Montana","value":"US-MT"},{"text":"Nebraska","value":"US-NE"},{"text":"Nevada","value":"US-NV"},{"text":"New Hampshire","value":"US-NH"},{"text":"New Jersey","value":"US-NJ"},{"text":"New Mexico","value":"US-NM"},{"text":"New York","value":"US-NY"},{"text":"North Carolina","value":"US-NC"},{"text":"North Dakota","value":"US-ND"},{"text":"Northern Mariana Islands","value":"US-MP"},{"text":"Ohio","value":"US-OH"},{"text":"Oklahoma","value":"US-OK"},{"text":"Oregon","value":"US-OR"},{"text":"Pennsylvania","value":"US-PA"},{"text":"Puerto Rico","value":"US-PR"},{"text":"Rhode Island","value":"US-RI"},{"text":"South Carolina","value":"US-SC"},{"text":"South Dakota","value":"US-SD"},{"text":"Tennessee","value":"US-TN"},{"text":"Texas","value":"US-TX"},{"text":"United States Minor Outlying Islands","value":"US-UM"},{"text":"Utah","value":"US-UT"},{"text":"Vermont","value":"US-VT"},{"text":"Virgin Islands","value":"US-VI"},{"text":"Virginia","value":"US-VA"},{"text":"Washington","value":"US-WA"},{"text":"West Virginia","value":"US-WV"},{"text":"Wisconsin","value":"US-WI"},{"text":"Wyoming","value":"US-WY"},{"text":"Alberta","value":"CA-AB"},{"text":"British Columbia","value":"CA-BC"},{"text":"Manitoba","value":"CA-MB"},{"text":"New Brunswick","value":"CA-NB"},{"text":"Newfoundland and Labrador","value":"CA-NL"},{"text":"Northwest Territories","value":"CA-NT"},{"text":"Nova Scotia","value":"CA-NS"},{"text":"Nunavut","value":"CA-NU"},{"text":"Ontario","value":"CA-ON"},{"text":"Prince Edward Island","value":"CA-PE"},{"text":"Quebec","value":"CA-QC"},{"text":"Saskatchewan","value":"CA-SK"},{"text":"Yukon","value":"CA-YT"}];
}

RedChirp.prototype.maskPhoneNumber = function(number)
{
    let telDigits = (number) => {
        number = ''+number;
        let only_digits = '';

        for ( let i = 0; i < number.length; i++ )
        {
            let cur_char = number.charAt(i);

            if ( cur_char === '0' || cur_char === '1' || cur_char === '2' || cur_char === '3' || cur_char === '4' || cur_char === '5' || cur_char === '6' || cur_char === '7' || cur_char === '8' || cur_char === '9' )
            {
                only_digits += cur_char;
            }
        }

        if ( only_digits.length == 0 ) return '';
        if ( only_digits.charAt(0) == '1' ) only_digits = only_digits.substring(1);

        return only_digits;
    };

    let mask = (mask, digits) => {
      let ret = '';

      while(mask.length > 0)
      {
        let mask_ch = mask.charAt(0);
        mask = mask.substring(1);

        if ( mask_ch == '#' )
        {
          if ( digits.length == 0 )
            return ret;

          ret += digits.charAt(0);
          digits = digits.substring(1);

          if ( digits.length == 0 )
            return ret;

          continue;
        }

        ret += mask_ch;
      }

      return ret;
    };

    return mask("1 (###) ###-####", telDigits(number));
}

RedChirp.prototype.linkProvideRedChirpPaymentMethod = function(router, organization_id)
{
    return window.location.origin + router.resolve({
        'name': 'red-chirp-provide-payment-method-start',
        'params' : {
            'organization_id': organization_id,
        }
    }).href;
}

RedChirp.prototype.maskMMDDYYYY = function(number)
{
    let telDigits = (number) => {
        number = ''+number;
        let only_digits = '';

        for ( let i = 0; i < number.length; i++ )
        {
            let cur_char = number.charAt(i);

            if ( cur_char === '0' || cur_char === '1' || cur_char === '2' || cur_char === '3' || cur_char === '4' || cur_char === '5' || cur_char === '6' || cur_char === '7' || cur_char === '8' || cur_char === '9' )
            {
                only_digits += cur_char;
            }
        }

        if ( only_digits.length == 0 ) return '';

        return only_digits;
    };

    let mask = (mask, digits) => {
      let ret = '';

      while(mask.length > 0)
      {
        let mask_ch = mask.charAt(0);
        mask = mask.substring(1);

        if ( mask_ch == '#' )
        {
          if ( digits.length == 0 )
            return ret;

          ret += digits.charAt(0);
          digits = digits.substring(1);

          if ( digits.length == 0 )
            return ret;

          continue;
        }

        ret += mask_ch;
      }

      return ret;
    };

    let only_digits = telDigits(number);

    if ( number.endsWith('/') && only_digits.length == 1 )
    {
        only_digits = '0'+only_digits;
    }

    if ( number.endsWith('/') && only_digits.length == 3 )
    {
        only_digits = only_digits.charAt(0) + only_digits.charAt(1) + '0' + only_digits.charAt(2);
    }

    return mask("##/##/####", only_digits);
}

RedChirp.prototype.maskUrl = function(url)
{
    if (url == null) return '';

    url = '' + url;

    if (url.length == 0) return '';

    let protocol = 'https://';
    if (url.startsWith('http://')) {
        protocol = 'http://';
        url = url.substring('http://'.length);
    } else if (url.startsWith('https://')) {
        url = url.substring('https://'.length);
    }

    if (url.startsWith('www.'))
        url = url.substring('www.'.length);

    if (url.endsWith('/'))
        url = url.substring(0, url.length - 1);

    url = url.replace(/^[^a-zA-Z0-9-]+/, '');

    return `${protocol}${url}`;
}

RedChirp.prototype.copy = function(text)
{
    navigator.clipboard.writeText(text).then(
        () => {
            this.snackbar('Copied to clipboard', 1500);
        },

        () => {
            this.snackbar('Unable to write to clipboard :/', 1500);
        }
    );
}

RedChirp.prototype.hasPersonalizeVariables = function(text)
{
    let has = (variable) => {
        if ( text.includes(variable) ) return true;

        variable = variable.replaceAll('_','-');
        if ( text.includes(variable) ) return true;

        return false;
    };

    return has('organization_id') 
        || has('organization_label') 
        || has('employee_label') 
        || has('employee_username') 
        || has('employee_first_name') 
        || has('first_name') 
        || has('employee_last_name') 
        || has('last_name');
}

RedChirp.prototype.parseVTableOptions = function(options, default_sort, sort_column_map)
{
    if ( sort_column_map == null )
        sort_column_map = {};

    let getSort = () => {

        if ( options == null ) return default_sort;
        if ( options.sortBy == null ) return default_sort;
        if ( options.sortBy.length == 0 ) return default_sort;

        if ( options.sortDesc == null || options.sortDesc.length == 0 ) options.sortDesc = [false];

        let ret = options.sortBy[0]+':'+(options.sortDesc[0] ? 'desc' : 'asc:nulls-last');

        let keys = Object.keys(sort_column_map);

        for ( let i = 0; i < keys.length; i++ )
        {
            let key = keys[i];
            let value = sort_column_map[key];

            ret = ret.replace(key+':desc',value+':desc');
            ret = ret.replace(key+':asc:nulls-last',value+':asc:nulls-last');
        }

        return ret;
    };

    let getOffset = () => {
        if ( options == null ) return 0; 
        if ( options.page == null ) return 0;
        if ( options.itemsPerPage == null ) return 0;
        
        return (options.page-1)*(options.itemsPerPage);
    };

    let getLimit = () => {
        if ( options == null ) return 50; 
        if ( options.itemsPerPage == null ) return 50;
        
        return options.itemsPerPage;
    };

    return {
        'offset': getOffset(),
        'limit': getLimit(),
        'sort': getSort(),
    };
}

RedChirp.prototype.styleInputLabel = function()
{
    return 'color: rgba(0,0,0,0.6); font-size: 13px';
}

RedChirp.prototype.integrationSupports = function(content_type, concept)
{
    let data = enum_data['integration_name'];

    let integration = data.find((el) => {return el.value == content_type;});

    if ( integration == null )
        return false;

    return integration.supports.find((el) => { return el == concept;}) != null;
}

RedChirp.prototype.isBlank = function(value)
{
    if ( value == null ) return true;
    if ( value.trim().length == 0 ) return true;

    return false;
}

RedChirp.prototype.compareNullsLast = function(a, b, is_desc)
{
   if ( a == null && b == null ) return 0;

   if ( a == null && b != null ) 
   {
        return 1;
   }
   if ( a != null && b == null ) 
   {
        return -1;
   }

   if (is_desc) 
   {
    return a < b ? 1 : -1;
   } 
   else 
   {
       return a < b ? -1 : 1;
   }
}

RedChirp.prototype.isCRMEnabledThatSupports = function(concept)
{
    let options = this.enumChoices('integration_name', false)
        .filter((el) => el.supports != null && el.supports.includes(concept))
        .filter((el) => this.$state.isCRMEnabled(el.value));

    return options.length > 0;
}

RedChirp.prototype.validationRuleInteger = function(limit_lower, limit_upper)
{
    return (x) => {
        let int_value = parseInt(x);

        if ( isNaN(int_value) )
         return false;

        if ( limit_lower != null && int_value < limit_lower )
            return false;

        if ( limit_upper != null && int_value > limit_upper )
            return false;    

        return true;
    };
}

RedChirp.prototype.cloneEvent = function(event)
{
    return {
        'metaKey': event?.metaKey ?? false,
        'ctrlKey': event?.ctrlKey ?? false,
        'shiftKey': event?.shiftKey ?? false,
    };
}

RedChirp.prototype.navigationClick = function(router, route, event)
{
    var new_tab = (event?.metaKey == true) || (event?.ctrlKey == true) || (event?.shiftKey == true);

    var route_name = route?.name ?? 'unknown';
    var is_page_url = route_name.toLowerCase().startsWith('https://') || route_name.toLowerCase().startsWith('http://');

    if ( new_tab )
    {
        if ( is_page_url )
        {
            window.open(route_name, '_blank');
            return;
        }

        window.open(router.resolve(route).href, '_blank');
        return;
    }

    
    if ( is_page_url )
    {
        document.location = route_name;
        return;
    }

    router.push(route);
}

RedChirp.prototype.isTollFree = function(endpoint)
{
    if (! endpoint) return false;

    return endpoint.startsWith('E164:+1800') ||
           endpoint.startsWith('E164:+1888') ||
           endpoint.startsWith('E164:+1877') ||
           endpoint.startsWith('E164:+1866') ||
           endpoint.startsWith('E164:+1855') ||
           endpoint.startsWith('E164:+1844') ||
           endpoint.startsWith('E164:+1833');
}

RedChirp.prototype.prettyTCRVettingStatus = function(vetting_status) // enum TCRVettingStatus.java / tcr_vetting_status
{
    if (! vetting_status) return '';

    let desc = this.pretty(vetting_status, 'enum_tcr_vetting_status');

    if (vetting_status.includes('rejected'))
    {
        return '<span class="font-weight-bold red--text">'+ desc + '</span>';
    }

    if (vetting_status == 'dca2-approved')
    {
        return '<span class="font-weight-medium green--text text--darken-1">'+ desc + '</span>';
    }

    return desc;
}

/**
 * Check if any enabled CRM integration supports a specific integration feature.
 *
 * @param {string} feature_value - The integration feature value to check (e.g., 'customers-auto-enrich-from-lightbox-submission')
 * @param {function} on_success - Callback function called with boolean result when check completes
 * @param {function} on_error - Optional callback function called if there's an error
 */
RedChirp.prototype.hasEnabledIntegrationFeature = function(feature_value, on_success, on_error)
{
    if ( on_error == null ) on_error = (error) => {  };

    let profile = this.$state.profile;

    if ( profile == null )
    {
        on_success(false);
        return;
    }

    // Check if enabled_integration_features exists in profile
    // TODO this if check can be removed in a few months from 6/2025, just initial push to populate automatically.
    if ( profile.enabled_integration_features === undefined )
    {
        // Profile doesn't have the new field yet - refresh profile using existing auth validation
        this.onValidateAuth(() => {
            // After refresh, check if we now have the field
            let updated_profile = this.$state.profile;
            if ( updated_profile && updated_profile.enabled_integration_features !== undefined )
            {
                let enabled_features = updated_profile.enabled_integration_features || [];
                let is_supported = enabled_features.includes(feature_value);
                on_success(is_supported);
            }
            else
            {
                // Profile refresh didn't add the field
            }
        }, () => {
            // Profile refresh failed
        });
        return;
    }

    // Get enabled features from profile data
    let enabled_features = profile.enabled_integration_features || [];
    let is_supported = enabled_features.includes(feature_value);

    // Call success callback immediately since we have the data in the profile
    on_success(is_supported);
}

/**
 * Initialize polling to check if front end build hash has changed since the user last refreshed the page
 * Includes an initial check and sets up periodic polling
 * Will bail early if already initialized
 */
RedChirp.prototype.initVersionPolling = function() {
    if (VersionService.getIsInitialized()) return;
    VersionService.setIsInitialized(true);

    const _doCheckAndEmit = async () => {
        try {
            await this.checkForNewVersionAndEmit();
        } catch (error) {
            // fail silently
        }
    };

    // initial check - just storing in session storage for later reference with no alerting since page was just loaded
    VersionService.checkForNewVersion();
    
    const versioning_timer = VersionService.getVersioningTimer();
    VersionService.setCurrentTimerId(versioning_timer.setInterval({
        callback: _doCheckAndEmit,
        interval: 1000 * 60 * 10, // run the check at most once every 10 mins, triggered by the first route change after the interval (failed api calls handled separately)
        // interval: 1000 * 20, // 20 seconds for testing only
        forcedInterval: 1000 * 60 * 60 * 24, // run the check and alert the user on tabs that have been open and not refreshed for 24 hours
    }));
}

/**
 * Manually check if front end build hash has changed since the user last refreshed the page
 * Emits 'new-version-available' event with boolean indicating if a new version is available
 */
RedChirp.prototype.checkForNewVersionAndEmit = async function() {
    try {
        const has_new_version = await VersionService.checkForNewVersion();
        this.$emit('new-version-available', has_new_version);
        return has_new_version;
    } catch (error) {
        return false;
    }
};

module.exports = RedChirp;
